import { ScriptSureAllergyResponse } from "models/scriptSure/scriptSureAllergyResponse";
import { ScriptSureDrugsResponse } from "models/scriptSure/scriptsureDrugsResponse";

export const mockMedicationSearch: ScriptSureDrugsResponse = {
  drugs: [
    {
      ROUTED_MED_ID: 174440,
      MED_ROUTED_MED_ID_DESC: "Adult Aspirin Regimen oral",
      GCN_SEQNO: "16995",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 342942,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 57381,
      MED_ROUTED_MED_ID_DESC: "Adult Low Dose Aspirin oral",
      GCN_SEQNO: "16995,22159",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 50344,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "P",
      Pharmacology:
        "Aspirin - low dose 81mg - for risk reduction of MI, stroke",
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 57381,
      MED_ROUTED_MED_ID_DESC: "Adult Low Dose Aspirin oral",
      GCN_SEQNO: "16995,22159",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 50344,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "C",
      Pharmacology:
        "Aspirin - low dose 81mg - for risk reduction of MI, stroke",
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 15315,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Extra Strength oral",
      GCN_SEQNO: "4330,73553",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 14352,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 155730,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Original oral",
      GCN_SEQNO: "59732",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 130360,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 159014,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Plus C/C(PE,DM) oral",
      GCN_SEQNO: "68317",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 162828,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "chlorphen/phenyleph/DM/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 153186,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Plus Cold (PE) oral",
      GCN_SEQNO: "65743",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 118794,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "chlorphenir/phenyleph/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 162346,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Plus Day-Night oral",
      GCN_SEQNO: "69887",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 199725,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "doxylamine/phenylep/DM/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 170221,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Plus Night (aspirin) oral",
      GCN_SEQNO: "69874",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 320145,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "doxylamine/phenylep/DM/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 187285,
      MED_ROUTED_MED_ID_DESC: "Alka-Seltzer Severe Cold oral",
      GCN_SEQNO: "65743",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 407638,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "chlorphenir/phenyleph/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 6349,
      MED_ROUTED_MED_ID_DESC: "Anacin oral",
      GCN_SEQNO: "4319,4320",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 6129,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 92551,
      MED_ROUTED_MED_ID_DESC: "Antacid and Pain Relief oral",
      GCN_SEQNO: "4329,59732",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 78864,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 958,
      MED_ROUTED_MED_ID_DESC: "Aspir-Trin oral",
      GCN_SEQNO: "4381,4384",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 952,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 77678,
      MED_ROUTED_MED_ID_DESC: "aspirin (bulk)",
      GCN_SEQNO: "4365,61289",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 64327,
      MED_ROUTE_ID: 35,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "10",
      multipletype: "True",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 13792,
      MED_ROUTED_MED_ID_DESC: "Aspirin Childrens oral",
      GCN_SEQNO: "4380",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 12905,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 1082,
      MED_ROUTED_MED_ID_DESC: "aspirin oral",
      GCN_SEQNO:
        "4338,4361,4376,4377,4380,4381,4382,4383,4384,4385,4386,4387,4388,12000,16656,16995,22159,24574,24575,24576,41823,64522,64934,82518",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 1076,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "C",
      Pharmacology:
        "Aspirin - (Brand = Bayer Aspirin, Bayer Low Strength Aspirin) = Salicylate-for Arthritis and Inflammation, Pain, Reduce Risk of MI",
      GenericName: "aspirin,aspirin/calcium/mag/aluminum",
      TypeId: "2",
      multipletype: "True",
      FormularyStatus: "-1",
      offerid: "2527",
    },
    {
      ROUTED_MED_ID: 1082,
      MED_ROUTED_MED_ID_DESC: "aspirin oral",
      GCN_SEQNO:
        "4338,4361,4376,4377,4380,4381,4382,4383,4384,4385,4386,4387,4388,12000,16656,16995,22159,24574,24575,24576,41823,64522,64934,82518",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 1076,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "P",
      Pharmacology:
        "Aspirin - (Brand = Bayer Aspirin, Bayer Low Strength Aspirin) = Salicylate-for Arthritis and Inflammation, Pain, Reduce Risk of MI",
      GenericName: "aspirin,aspirin/calcium/mag/aluminum",
      TypeId: "2",
      multipletype: "True",
      FormularyStatus: "-1",
      offerid: "2527",
    },
    {
      ROUTED_MED_ID: 4088,
      MED_ROUTED_MED_ID_DESC: "aspirin rectal",
      GCN_SEQNO: "4366,4367,4368,4369,4370,4371,4373,4374,4375",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 1076,
      MED_ROUTE_ID: 27,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "True",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 178377,
      MED_ROUTED_MED_ID_DESC:
        "aspirin,buffered (calcium carbonate-magnesium) oral",
      GCN_SEQNO: "4334,27893,27896,66232",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 361501,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium carb/magnesium",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 178362,
      MED_ROUTED_MED_ID_DESC:
        "aspirin,buffered(calcium carb-magnesium-aluminum hydrx) oral",
      GCN_SEQNO: "4335,4338,39786,39787",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 361420,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium/mag/aluminum",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 94307,
      MED_ROUTED_MED_ID_DESC: "aspirin-acetaminophen oral",
      GCN_SEQNO: "59810",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 80155,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 103,
      MED_ROUTED_MED_ID_DESC: "aspirin-acetaminophen-caffeine oral",
      GCN_SEQNO: "4344,34096,40186,47014,62538,63527,70842,83546",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 102,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 180933,
      MED_ROUTED_MED_ID_DESC: "aspirin-acetaminophen-diphenhydramine oral",
      GCN_SEQNO: "81965",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 374099,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophn/diphenhyd",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 1633,
      MED_ROUTED_MED_ID_DESC: "aspirin-caffeine oral",
      GCN_SEQNO: "4318,4319,4320,65991,66247,66381,68068,83536",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 1619,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 13890,
      MED_ROUTED_MED_ID_DESC: "aspirin-calcium carbonate oral",
      GCN_SEQNO: "31299,68853",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 12996,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium carbonate",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 155827,
      MED_ROUTED_MED_ID_DESC: "aspirin-diphenhydramine citrate oral",
      GCN_SEQNO: "67359",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 130825,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/diphenhydramine citrat",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 17175,
      MED_ROUTED_MED_ID_DESC: "aspirin-dipyridamole oral",
      GCN_SEQNO: "40303",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 16154,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "C",
      Pharmacology:
        "Dipyridamole + aspirin (Brand = Aggrenox) = Combination antiplatelet aggregation inhibitor - to reduce Stroke in TIA and Post Thrombosis",
      GenericName: "aspirin/dipyridamole",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 17175,
      MED_ROUTED_MED_ID_DESC: "aspirin-dipyridamole oral",
      GCN_SEQNO: "40303",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 16154,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "Z",
      Pharmacology:
        "Dipyridamole + aspirin (Brand = Aggrenox) = Combination antiplatelet aggregation inhibitor - to reduce Stroke in TIA and Post Thrombosis",
      GenericName: "aspirin/dipyridamole",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 172549,
      MED_ROUTED_MED_ID_DESC: "aspirin-omeprazole oral",
      GCN_SEQNO: "76607,76608",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 338460,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "C",
      Pharmacology:
        "Aspirin + omeprazole.- (Brand = Yosprala) = Antiplatelet + proton pump inhibitor - for prevention of cardio / cerebrovascular events in person at risk for ulcers",
      GenericName: "aspirin/omeprazole",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 172549,
      MED_ROUTED_MED_ID_DESC: "aspirin-omeprazole oral",
      GCN_SEQNO: "76607,76608",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 338460,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "G",
      Pharmacology:
        "Aspirin + omeprazole.- (Brand = Yosprala) = Antiplatelet + proton pump inhibitor - for prevention of cardio / cerebrovascular events in person at risk for ulcers",
      GenericName: "aspirin/omeprazole",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 94207,
      MED_ROUTED_MED_ID_DESC: "aspirin-sodium bicarbonate-citric acid oral",
      GCN_SEQNO: "4329,4330,51163,59732,73553",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 80082,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "True",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 157987,
      MED_ROUTED_MED_ID_DESC: "Back and Body Pain Reliever oral",
      GCN_SEQNO: "68068",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 151889,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 158412,
      MED_ROUTED_MED_ID_DESC: "Bayer Advanced oral",
      GCN_SEQNO: "4377",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 155985,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 153569,
      MED_ROUTED_MED_ID_DESC: "Bayer Aspirin (with caffeine) oral",
      GCN_SEQNO: "65991",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 119175,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 11646,
      MED_ROUTED_MED_ID_DESC: "Bayer Aspirin oral",
      GCN_SEQNO: "4376,4377,4381",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 10897,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "C",
      Pharmacology:
        "Aspirin = Salicylate-for Arthritis and Inflammation, Pain, Reduce Risk of MI",
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 11646,
      MED_ROUTED_MED_ID_DESC: "Bayer Aspirin oral",
      GCN_SEQNO: "4376,4377,4381",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 10897,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "P",
      Pharmacology:
        "Aspirin = Salicylate-for Arthritis and Inflammation, Pain, Reduce Risk of MI",
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 158386,
      MED_ROUTED_MED_ID_DESC: "Bayer Back and Body oral",
      GCN_SEQNO: "68068",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 155807,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 162824,
      MED_ROUTED_MED_ID_DESC: "Bayer Chewable Low Dose Aspirin oral",
      GCN_SEQNO: "4380",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 206045,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "1794",
    },
    {
      ROUTED_MED_ID: 21047,
      MED_ROUTED_MED_ID_DESC: "Bayer Low Dose Aspirin oral",
      GCN_SEQNO: "16995",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 19695,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 14355,
      MED_ROUTED_MED_ID_DESC: "Bayer Plus Extra Strength oral",
      GCN_SEQNO: "4338",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 13433,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium/mag/aluminum",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 155870,
      MED_ROUTED_MED_ID_DESC: "Bayer PM oral",
      GCN_SEQNO: "67359",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 131080,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/diphenhydramine citrat",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 154209,
      MED_ROUTED_MED_ID_DESC: "BC Arthritis oral",
      GCN_SEQNO: "66381",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 119801,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 184512,
      MED_ROUTED_MED_ID_DESC: "BC Max Strength oral",
      GCN_SEQNO: "83546",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 391518,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 57708,
      MED_ROUTED_MED_ID_DESC: "BC Pain Relief oral",
      GCN_SEQNO: "4322,66247",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 50667,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine,aspirin/salicylamide/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 57503,
      MED_ROUTED_MED_ID_DESC: "Bufferin oral",
      GCN_SEQNO: "27896,66232",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 50466,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium carb/magnesium",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 3391,
      MED_ROUTED_MED_ID_DESC: "butalbital-aspirin-caffeine oral",
      GCN_SEQNO: "4308,4309",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 3347,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "P",
      Pharmacology:
        "Butalbital + aspirin + caffeine (Brand = Fiorinal) = barbiturate + salicylate - for Tension Headache",
      GenericName: "butalbital/aspirin/caffeine",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "2611",
    },
    {
      ROUTED_MED_ID: 2125,
      MED_ROUTED_MED_ID_DESC: "carisoprodol-aspirin oral",
      GCN_SEQNO: "4661",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 2099,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "P",
      Pharmacology:
        "Carisoprodol + ASA (Brand = Soma Compound) = centrally acting muscle relaxant + salicylate - for Painful Musculoskeletal Conditions",
      GenericName: "carisoprodol/aspirin",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 2124,
      MED_ROUTED_MED_ID_DESC: "carisoprodol-aspirin-codeine oral",
      GCN_SEQNO: "4173,48518",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 2098,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "P",
      Pharmacology:
        "Carisoprodol + ASA = centrally acting muscle relaxant + salicylate + codeine-opioid - for Musculoskeletal Conditions",
      GenericName: "carisoprodol/aspirin/codeine",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 3438,
      MED_ROUTED_MED_ID_DESC: "Children's Aspirin oral",
      GCN_SEQNO: "4380",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 3392,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "1794",
    },
    {
      ROUTED_MED_ID: 57613,
      MED_ROUTED_MED_ID_DESC: "Children's Non-Aspirin oral",
      GCN_SEQNO: "4481,4484,4494,16947",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 50576,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "acetaminophen",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 153176,
      MED_ROUTED_MED_ID_DESC: "chlorpheniramine-phenyleph-aspirin oral",
      GCN_SEQNO: "65743",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 118784,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "chlorphenir/phenyleph/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 158987,
      MED_ROUTED_MED_ID_DESC: "chlorpheniramine-phenyleph-DM-ASA oral",
      GCN_SEQNO: "68317",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 162505,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "chlorphen/phenyleph/DM/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 17845,
      MED_ROUTED_MED_ID_DESC: "Cold Relief oral",
      GCN_SEQNO: "884,904,22634,32515,46480,52741,65743",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 16804,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName:
        "acetaminophen/diphenhydramine,chlorphenir/phenyleph/aspirin,DM/PPA/Acetaminophen/Chlorphen,DM/pseudoephed/acetaminoph/cpm,guaifenesin/DM/pseudoephedrine,phenylephrine/acetaminophn/cpm",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 76298,
      MED_ROUTED_MED_ID_DESC: "Cold Relief Plus oral",
      GCN_SEQNO: "52741,65743",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 63070,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName:
        "chlorphenir/phenyleph/aspirin,phenylephrine/acetaminophn/cpm",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 162209,
      MED_ROUTED_MED_ID_DESC: "doxylamine-PE-DM-ASA oral",
      GCN_SEQNO: "69874",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 198385,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "doxylamine/phenylep/DM/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 169880,
      MED_ROUTED_MED_ID_DESC: "Durlaza oral",
      GCN_SEQNO: "64934",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 314385,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 10695,
      MED_ROUTED_MED_ID_DESC: "Ecotrin Low Strength oral",
      GCN_SEQNO: "16995",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 10042,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 12051,
      MED_ROUTED_MED_ID_DESC: "Ecotrin oral",
      GCN_SEQNO: "4381",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 11283,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "1795",
    },
    {
      ROUTED_MED_ID: 144946,
      MED_ROUTED_MED_ID_DESC: "Effervescent Pain Relief Antacid oral",
      GCN_SEQNO: "59732,73553",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 110675,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 21141,
      MED_ROUTED_MED_ID_DESC: "Enteric Coated Aspirin oral",
      GCN_SEQNO: "4381,4383,16995",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 19789,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "1349",
    },
    {
      ROUTED_MED_ID: 145038,
      MED_ROUTED_MED_ID_DESC: "Excedrin Extra Strength oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 110766,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 7466,
      MED_ROUTED_MED_ID_DESC: "Excedrin Migraine oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 7169,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 172590,
      MED_ROUTED_MED_ID_DESC: "Extra Pain Relief oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 338560,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 14426,
      MED_ROUTED_MED_ID_DESC: "Extra Strength Bayer oral",
      GCN_SEQNO: "4377",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 13496,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 16951,
      MED_ROUTED_MED_ID_DESC: "Extraprin oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 15933,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 184415,
      MED_ROUTED_MED_ID_DESC: "Goody's Back and Body Pain oral",
      GCN_SEQNO: "59810",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 390960,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 89306,
      MED_ROUTED_MED_ID_DESC: "Goody's Extra Strength oral",
      GCN_SEQNO: "4344,40186,62538,63527,70842",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 75626,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 184556,
      MED_ROUTED_MED_ID_DESC: "Goody's Hangover oral",
      GCN_SEQNO: "83536",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 391818,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 20680,
      MED_ROUTED_MED_ID_DESC:
        "Headache Relief (ASA-acetaminophn-caffeine) oral",
      GCN_SEQNO: "4344,40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 19341,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 17840,
      MED_ROUTED_MED_ID_DESC: "Medi-Seltzer oral",
      GCN_SEQNO: "4329",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 16800,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 64327,
      MED_ROUTED_MED_ID_DESC: "Migraine Formula oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 57080,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 63288,
      MED_ROUTED_MED_ID_DESC: "Migraine Relief oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 56109,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 8250,
      MED_ROUTED_MED_ID_DESC: "Non-Aspirin Extra Strength oral",
      GCN_SEQNO: "4473,4485,4490",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 7877,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "acetaminophen",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "1749",
    },
    {
      ROUTED_MED_ID: 523,
      MED_ROUTED_MED_ID_DESC: "Non-Aspirin oral",
      GCN_SEQNO:
        "1112,4473,4479,4481,4484,4486,4489,4490,4493,4494,16947,16948",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 522,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "acetaminophen,pseudoephedrine/acetaminophen",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 3852,
      MED_ROUTED_MED_ID_DESC: "Non-Aspirin Pain Relief oral",
      GCN_SEQNO: "4489,4490,4494,16947",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 3796,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "acetaminophen",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 32812,
      MED_ROUTED_MED_ID_DESC: "Non-Aspirin PM oral",
      GCN_SEQNO: "3699,45404",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 26365,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "acetaminophen/diphenhydramine,acetaminophen/dp-hydramine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 1817,
      MED_ROUTED_MED_ID_DESC: "Norgesic Forte oral",
      GCN_SEQNO: "4312",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 1798,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "orphenadrine/aspirin/caffeine",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 6370,
      MED_ROUTED_MED_ID_DESC: "Norgesic oral",
      GCN_SEQNO: "4311",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 6150,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology:
        "Orphenadrine + ASA + caffeine = central muscle relaxant + analgesic-for Muscle Spasm with Mild to Moderate Pain",
      GenericName: "orphenadrine/aspirin/caffeine",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 216,
      MED_ROUTED_MED_ID_DESC: "orphenadrine-ASA-caffeine oral",
      GCN_SEQNO: "4311,4312",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 215,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "orphenadrine/aspirin/caffeine",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 16871,
      MED_ROUTED_MED_ID_DESC: "Orphengesic Forte oral",
      GCN_SEQNO: "4312",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 15854,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "orphenadrine/aspirin/caffeine",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 9396,
      MED_ROUTED_MED_ID_DESC: "Pain Relief (acetaminophen) oral",
      GCN_SEQNO:
        "4319,4329,4344,4472,4473,4484,4486,4489,4490,4494,22123,60241",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 3327,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName:
        "acetaminophen,aspirin/acetaminophen/caffeine,aspirin/caffeine,aspirin/sod bicarb/citric acid",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: "1749",
    },
    {
      ROUTED_MED_ID: 185804,
      MED_ROUTED_MED_ID_DESC: "Pain Relief (aspirin-caffeine) oral",
      GCN_SEQNO: "66247",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 399561,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 180959,
      MED_ROUTED_MED_ID_DESC: "Pain Relief PM (w-aspirin) oral",
      GCN_SEQNO: "81965",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 373696,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophn/diphenhyd",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 166493,
      MED_ROUTED_MED_ID_DESC: "Pain Reliever (acetaminophen-aspirin-caff) oral",
      GCN_SEQNO: "4344,40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 259365,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 63289,
      MED_ROUTED_MED_ID_DESC: "Pain Reliever Plus oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 56110,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 17662,
      MED_ROUTED_MED_ID_DESC: "Pain-Off oral",
      GCN_SEQNO: "40186",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 16625,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 162306,
      MED_ROUTED_MED_ID_DESC: "PE-DM-ASA/doxylamine-PE-DM-ASA oral",
      GCN_SEQNO: "69887",
      MED_NAME_TYPE_CD: "2",
      MED_NAME_ID: 199065,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "doxylamine/phenylep/DM/aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 21666,
      MED_ROUTED_MED_ID_DESC: "St Joseph Aspirin oral",
      GCN_SEQNO: "4380,16995",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 20298,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 57391,
      MED_ROUTED_MED_ID_DESC: "St. Joseph Aspirin oral",
      GCN_SEQNO: "4376,4380,16995",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 50354,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 154157,
      MED_ROUTED_MED_ID_DESC: "Stanback oral",
      GCN_SEQNO: "66247",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 119751,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 1535,
      MED_ROUTED_MED_ID_DESC: "Tri-Buffered Aspirin oral",
      GCN_SEQNO: "4334,27896",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 1523,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium carb/magnesium",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 19866,
      MED_ROUTED_MED_ID_DESC: "Vanquish oral",
      GCN_SEQNO: "34096",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 18594,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/acetaminophen/caffeine",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 181966,
      MED_ROUTED_MED_ID_DESC: "Vazalore oral",
      GCN_SEQNO: "4361,82518",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 378362,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 160300,
      MED_ROUTED_MED_ID_DESC: "Women's Aspirin with Calcium oral",
      GCN_SEQNO: "68853",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 176865,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: null,
      Pharmacology: null,
      GenericName: "aspirin/calcium carbonate",
      TypeId: "2",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 172552,
      MED_ROUTED_MED_ID_DESC: "Yosprala oral",
      GCN_SEQNO: "76607,76608",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 338463,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "C",
      Pharmacology:
        "Aspirin + omeprazole.= Antiplatelet + proton pump inhibitor - for prevention of cardio / cerebrovascular events in person at risk for ulcers",
      GenericName: "aspirin/omeprazole",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
    {
      ROUTED_MED_ID: 172552,
      MED_ROUTED_MED_ID_DESC: "Yosprala oral",
      GCN_SEQNO: "76607,76608",
      MED_NAME_TYPE_CD: "1",
      MED_NAME_ID: 338463,
      MED_ROUTE_ID: 24,
      MED_STATUS_CD: "0",
      DrugGroup: "G",
      Pharmacology:
        "Aspirin + omeprazole.= Antiplatelet + proton pump inhibitor - for prevention of cardio / cerebrovascular events in person at risk for ulcers",
      GenericName: "aspirin/omeprazole",
      TypeId: "1",
      multipletype: "False",
      FormularyStatus: "-1",
      offerid: null,
    },
  ],
};

export const mockAllergySearch: ScriptSureAllergyResponse = [
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 7525,
    Descr: "10ml Plastic Cartridge",
  },
  {
    allergyType: "1",
    allergyId: "8032",
    ROUTED_MED_ID: 167249,
    Descr: "12 Hour (xylometazoline) Nasal nasal",
  },
  {
    allergyType: "1",
    allergyId: "16937",
    ROUTED_MED_ID: 175318,
    Descr: "12 Hour Nasal Decongestant (PSE) oral",
  },
  {
    allergyType: "1",
    allergyId: "1060,1154",
    ROUTED_MED_ID: 15218,
    Descr: "12 Hour Nasal Decongestant oral",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 64180,
    Descr: "12 Hour Nasal nasal",
  },
  {
    allergyType: "1",
    allergyId: "1154",
    ROUTED_MED_ID: 14769,
    Descr: "12 Hour Nasal oral",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 9800,
    Descr: "12 Hour Nasal Relief Spray",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 6658,
    Descr: "12 Hour Nasal Spray nasal",
  },
  {
    allergyType: "1",
    allergyId: "8042",
    ROUTED_MED_ID: 54216,
    Descr: "12 Hour Nose Drops nasal",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 63205,
    Descr: "12-Hour Nasal nasal",
  },
  {
    allergyType: "1",
    allergyId: "73576",
    ROUTED_MED_ID: 167949,
    Descr: "1st Base",
  },
  {
    allergyType: "1",
    allergyId: "11053",
    ROUTED_MED_ID: 86377,
    Descr: "20-20 Eyeglass Cleaner",
  },
  {
    allergyType: "1",
    allergyId: "73300",
    ROUTED_MED_ID: 170990,
    Descr: "24 Hour Allergy Relief nasal",
  },
  {
    allergyType: "1",
    allergyId: "72054",
    ROUTED_MED_ID: 175085,
    Descr: "24 Hour Nasal Allergy nasal",
  },
  {
    allergyType: "1",
    allergyId: "12087",
    ROUTED_MED_ID: 144238,
    Descr: "3M Nexcare Stomaseal",
  },
  {
    allergyType: "1",
    allergyId: "10496",
    ROUTED_MED_ID: 11653,
    Descr: "3M Tegasorb Large Square topical",
  },
  {
    allergyType: "1",
    allergyId: "10492",
    ROUTED_MED_ID: 11654,
    Descr: "3M Tegasorb Medium Oval topical",
  },
  {
    allergyType: "1",
    allergyId: "10491",
    ROUTED_MED_ID: 11655,
    Descr: "3M Tegasorb Small Oval topical",
  },
  {
    allergyType: "1",
    allergyId: "10489",
    ROUTED_MED_ID: 11657,
    Descr: "3M Tegasorb Small Square topical",
  },
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 7522,
    Descr: "3ml Glass Cartridge",
  },
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 7484,
    Descr: "3ml Plastic Cartridge",
  },
  {
    allergyType: "1",
    allergyId: "8032",
    ROUTED_MED_ID: 153220,
    Descr: "4 Way Moisturizing Relief nasal",
  },
  {
    allergyType: "1",
    allergyId: "8062",
    ROUTED_MED_ID: 151888,
    Descr: "4 Way nasal",
  },
  {
    allergyType: "1",
    allergyId: "67355",
    ROUTED_MED_ID: 155835,
    Descr: "4 Way Saline Moisturizing nasal",
  },
  {
    allergyType: "1",
    allergyId: "22126,73058",
    ROUTED_MED_ID: 154832,
    Descr: "4-N-1 No Rinse Wash topical",
  },
  {
    allergyType: "1",
    allergyId: "8025",
    ROUTED_MED_ID: 78394,
    Descr: "4-Way Fast Acting nasal",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 151170,
    Descr: "4-Way Long Last nasal",
  },
  {
    allergyType: "1",
    allergyId: "8024",
    ROUTED_MED_ID: 151169,
    Descr: "4-Way Menthol nasal",
  },
  {
    allergyType: "3",
    allergyId: "900116",
    ROUTED_MED_ID: 0,
    Descr: "5-ALFA REDUCTASE INHIBITOR, AZASTEROIDS",
  },
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 7524,
    Descr: "5ml Glass Cartridge",
  },
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 7485,
    Descr: "5ml Plastic Cartridge",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 54224,
    Descr: "666  12 Hour nasal",
  },
  {
    allergyType: "1",
    allergyId: "31572,64013",
    ROUTED_MED_ID: 172601,
    Descr: "A and D Diaper Rash Cream topical",
  },
  {
    allergyType: "1",
    allergyId: "4922",
    ROUTED_MED_ID: 56626,
    Descr: "A-Spas (dicyclomine) intramuscular",
  },
  {
    allergyType: "1",
    allergyId: "4868",
    ROUTED_MED_ID: 11569,
    Descr: "A-Spas sublingual",
  },
  {
    allergyType: "0",
    allergyId: "18376",
    ROUTED_MED_ID: 0,
    Descr: "A2 beta casein",
  },
  {
    allergyType: "1",
    allergyId: "6514,6515,6516",
    ROUTED_MED_ID: 8957,
    Descr: "Abbokinase injection",
  },
  {
    allergyType: "1",
    allergyId: "84704,84705",
    ROUTED_MED_ID: 186560,
    Descr: "Abilify Asimtufii intramuscular",
  },
  {
    allergyType: "1",
    allergyId: "5350",
    ROUTED_MED_ID: 20229,
    Descr: "Absorbase topical",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 12608,
    Descr: "Accu-Chek Easy Diabetes Care",
  },
  {
    allergyType: "1",
    allergyId: "19413",
    ROUTED_MED_ID: 5406,
    Descr: "Accu-Chek Easy Diabetes Meter",
  },
  {
    allergyType: "1",
    allergyId: "50327",
    ROUTED_MED_ID: 2353,
    Descr: "Accu-Chek Easy Glucose Control",
  },
  {
    allergyType: "1",
    allergyId: "11569",
    ROUTED_MED_ID: 13366,
    Descr: "Accu-Chek Easy Hospital Test",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 16636,
    Descr: "Accu-Chek Easy Test",
  },
  {
    allergyType: "1",
    allergyId: "11186",
    ROUTED_MED_ID: 175212,
    Descr: "Accu-Chek Fastclix Lancet Drum",
  },
  {
    allergyType: "1",
    allergyId: "11186,53036",
    ROUTED_MED_ID: 155784,
    Descr: "Accu-Chek FastClix Lancing Device",
  },
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 152375,
    Descr: "Accu-Chek Linkassist Insertion Device",
  },
  {
    allergyType: "1",
    allergyId: "10959",
    ROUTED_MED_ID: 147714,
    Descr: "Accu-Chek Spirit Clip Case",
  },
  {
    allergyType: "1",
    allergyId: "34021",
    ROUTED_MED_ID: 152376,
    Descr: "Accu-Chek Spirit Leather Case",
  },
  {
    allergyType: "1",
    allergyId: "10436,10437,10438,10439,10440,10441,10447,10451,22936,24206",
    ROUTED_MED_ID: 64499,
    Descr: "ACE Elastic Bandage topical",
  },
  {
    allergyType: "1",
    allergyId: "10539",
    ROUTED_MED_ID: 11892,
    Descr: "ACE Multi-Use Plastic Gloves",
  },
  {
    allergyType: "1",
    allergyId: "10436,10438,10440,10447",
    ROUTED_MED_ID: 75375,
    Descr: "ACE Rubber Elastic Bandage topical",
  },
  {
    allergyType: "2",
    allergyId: "67235",
    ROUTED_MED_ID: 155577,
    Descr: "acesulfame potassium (bulk)",
  },
  {
    allergyType: "2",
    allergyId: "47887",
    ROUTED_MED_ID: 21399,
    Descr: "acesulfame potassium-isomalt oral",
  },
  {
    allergyType: "1",
    allergyId: "4490",
    ROUTED_MED_ID: 20727,
    Descr: "Acetaminophen Non Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "8098,48554",
    ROUTED_MED_ID: 8071,
    Descr: "Acetasol HC otic (ear)",
  },
  {
    allergyType: "1",
    allergyId: "8101",
    ROUTED_MED_ID: 8136,
    Descr: "Acetasol otic (ear)",
  },
  {
    allergyType: "1",
    allergyId: "8098,48554",
    ROUTED_MED_ID: 22098,
    Descr: "Acetasol-HC otic (ear)",
  },
  {
    allergyType: "3",
    allergyId: "1056",
    ROUTED_MED_ID: 0,
    Descr: "ACHYRANTHES ASPERA",
  },
  {
    allergyType: "0",
    allergyId: "14728",
    ROUTED_MED_ID: 0,
    Descr: "Achyranthes aspera",
  },
  {
    allergyType: "0",
    allergyId: "10983",
    ROUTED_MED_ID: 0,
    Descr: "acitazanolast",
  },
  {
    allergyType: "1",
    allergyId: "59137",
    ROUTED_MED_ID: 166090,
    Descr: "Acne Foaming Wash topical",
  },
  {
    allergyType: "1",
    allergyId: "15730",
    ROUTED_MED_ID: 146035,
    Descr: "Acne Wash topical",
  },
  {
    allergyType: "2",
    allergyId: "4750",
    ROUTED_MED_ID: 76516,
    Descr: "aconite-arsenic-yellow jasmine oral",
  },
  {
    allergyType: "0",
    allergyId: "3921",
    ROUTED_MED_ID: 0,
    Descr: "acrivastine",
  },
  {
    allergyType: "2",
    allergyId: "21721",
    ROUTED_MED_ID: 1886,
    Descr: "acrivastine-pseudoephedrine oral",
  },
  {
    allergyType: "1",
    allergyId: "6508,16922",
    ROUTED_MED_ID: 8962,
    Descr: "Activase intravenous",
  },
  {
    allergyType: "1",
    allergyId: "67121",
    ROUTED_MED_ID: 155435,
    Descr: "AcuWash topical",
  },
  {
    allergyType: "0",
    allergyId: "19248",
    ROUTED_MED_ID: 0,
    Descr: "adagrasib",
  },
  {
    allergyType: "2",
    allergyId: "84185",
    ROUTED_MED_ID: 185563,
    Descr: "adagrasib oral",
  },
  {
    allergyType: "1",
    allergyId: "84819,86039",
    ROUTED_MED_ID: 187508,
    Descr: "adalimumab-adbm(CF) pen Psoriasis-Uveitis Start subcutaneous",
  },
  {
    allergyType: "1",
    allergyId: "10270",
    ROUTED_MED_ID: 150981,
    Descr: "Adapt Ostomy Paste",
  },
  {
    allergyType: "1",
    allergyId: "10169",
    ROUTED_MED_ID: 89230,
    Descr: "Adapt Paste",
  },
  {
    allergyType: "1",
    allergyId: "70405",
    ROUTED_MED_ID: 165650,
    Descr: "Adasuve inhalation",
  },
  {
    allergyType: "1",
    allergyId: "10959",
    ROUTED_MED_ID: 89874,
    Descr: "Add-Pro Spike-Tube-Syrn Assmb",
  },
  {
    allergyType: "1",
    allergyId: "10618",
    ROUTED_MED_ID: 62647,
    Descr: "Additiv Set W/Accuclamp/Flasht",
  },
  {
    allergyType: "1",
    allergyId: "10844",
    ROUTED_MED_ID: 62593,
    Descr: "Additive Non-Sterile Cap for Accumeasure",
  },
  {
    allergyType: "1",
    allergyId: "71525,71526,71527,71528,71529",
    ROUTED_MED_ID: 165196,
    Descr: "Adempas oral",
  },
  {
    allergyType: "0",
    allergyId: "14433",
    ROUTED_MED_ID: 0,
    Descr: "Adhatoda vasica",
  },
  {
    allergyType: "3",
    allergyId: "1030",
    ROUTED_MED_ID: 0,
    Descr: "ADHATODA VASICA",
  },
  {
    allergyType: "2",
    allergyId: "77850",
    ROUTED_MED_ID: 174295,
    Descr: "adjuvant AS01B (PF), component vial 1 of 2 intramuscular",
  },
  {
    allergyType: "2",
    allergyId: "84742",
    ROUTED_MED_ID: 186604,
    Descr: "adjuvant AS01E (PF), component (vial 1 of 2) intramuscular",
  },
  {
    allergyType: "0",
    allergyId: "14910",
    ROUTED_MED_ID: 0,
    Descr: "ado-trastuzumab emtansine",
  },
  {
    allergyType: "2",
    allergyId: "70635,70636",
    ROUTED_MED_ID: 163562,
    Descr: "ado-trastuzumab emtansine intravenous",
  },
  {
    allergyType: "1",
    allergyId: "8022",
    ROUTED_MED_ID: 8965,
    Descr: "Adrenalin nasal",
  },
  {
    allergyType: "1",
    allergyId: "23835",
    ROUTED_MED_ID: 157288,
    Descr: "Adult Aerosol Mask",
  },
  {
    allergyType: "1",
    allergyId: "16995",
    ROUTED_MED_ID: 4432,
    Descr: "Adult Aspirin EC Low Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "4380,22159",
    ROUTED_MED_ID: 57382,
    Descr: "Adult Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "16995",
    ROUTED_MED_ID: 174440,
    Descr: "Adult Aspirin Regimen oral",
  },
  {
    allergyType: "1",
    allergyId: "16995,22159",
    ROUTED_MED_ID: 57381,
    Descr: "Adult Low Dose Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "30759",
    ROUTED_MED_ID: 21472,
    Descr: "Adult Mask",
  },
  {
    allergyType: "1",
    allergyId: "24120",
    ROUTED_MED_ID: 95022,
    Descr: "Adult Nasal Decongestant oral",
  },
  {
    allergyType: "1",
    allergyId: "59707",
    ROUTED_MED_ID: 157712,
    Descr: "Adult Robitussin Nasal Relief oral",
  },
  {
    allergyType: "1",
    allergyId: "47013",
    ROUTED_MED_ID: 157713,
    Descr: "Adult Robitussin Nighttime Nasal Relief oral",
  },
  {
    allergyType: "1",
    allergyId: "23852",
    ROUTED_MED_ID: 151234,
    Descr: "Adult Washcloth topical",
  },
  {
    allergyType: "1",
    allergyId: "72713",
    ROUTED_MED_ID: 170469,
    Descr: "Advanced Acne Wash topical",
  },
  {
    allergyType: "1",
    allergyId: "2701,2706",
    ROUTED_MED_ID: 160675,
    Descr: "Advanced Antacid-Antigas oral",
  },
  {
    allergyType: "1",
    allergyId: "77920",
    ROUTED_MED_ID: 1894,
    Descr: "Aerochamber Mask Large",
  },
  {
    allergyType: "1",
    allergyId: "77917",
    ROUTED_MED_ID: 1895,
    Descr: "Aerochamber Mask Small",
  },
  {
    allergyType: "1",
    allergyId: "21900",
    ROUTED_MED_ID: 94479,
    Descr: "Aerochamber Max - Mask Large",
  },
  {
    allergyType: "1",
    allergyId: "21900",
    ROUTED_MED_ID: 94480,
    Descr: "Aerochamber Max - Mask Medium",
  },
  {
    allergyType: "1",
    allergyId: "21900",
    ROUTED_MED_ID: 94481,
    Descr: "Aerochamber Max - Mask Small",
  },
  {
    allergyType: "1",
    allergyId: "77919",
    ROUTED_MED_ID: 12627,
    Descr: "Aerochamber Medium Mask",
  },
  {
    allergyType: "1",
    allergyId: "77920",
    ROUTED_MED_ID: 164412,
    Descr: "Aerochamber Plus Flow-Vu,Large Mask",
  },
  {
    allergyType: "1",
    allergyId: "77919",
    ROUTED_MED_ID: 164411,
    Descr: "Aerochamber Plus Flow-Vu,Medium Mask",
  },
  {
    allergyType: "1",
    allergyId: "77917",
    ROUTED_MED_ID: 164410,
    Descr: "Aerochamber Plus Flow-Vu,Small Mask",
  },
  {
    allergyType: "1",
    allergyId: "77920",
    ROUTED_MED_ID: 95353,
    Descr: "Aerochamber Plus Z Stat Large Mask",
  },
  {
    allergyType: "1",
    allergyId: "77919",
    ROUTED_MED_ID: 95109,
    Descr: "AeroChamber Plus Z Stat Medium Mask",
  },
  {
    allergyType: "1",
    allergyId: "77917",
    ROUTED_MED_ID: 95111,
    Descr: "AeroChamber Plus Z Stat Small Mask",
  },
  {
    allergyType: "1",
    allergyId: "21899",
    ROUTED_MED_ID: 19833,
    Descr: "AeroChamber Plus-Medium Mask",
  },
  {
    allergyType: "1",
    allergyId: "21899",
    ROUTED_MED_ID: 16399,
    Descr: "Aerochamber/Mask",
  },
  {
    allergyType: "1",
    allergyId: "34669",
    ROUTED_MED_ID: 18167,
    Descr: "Aerogear Action Asthma Kit",
  },
  {
    allergyType: "1",
    allergyId: "11554",
    ROUTED_MED_ID: 63032,
    Descr: "Aerosonic Nebulizer with Case",
  },
  {
    allergyType: "1",
    allergyId: "8037,8039,8041,8042",
    ROUTED_MED_ID: 54213,
    Descr: "Afrin (oxymetazoline) nasal",
  },
  {
    allergyType: "1",
    allergyId: "8064",
    ROUTED_MED_ID: 16971,
    Descr: "Afrin Childrens (phenylephrine) nasal",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 12272,
    Descr: "Afrin Extra Moisturizing nasal",
  },
  {
    allergyType: "1",
    allergyId: "8036",
    ROUTED_MED_ID: 20292,
    Descr: "Afrin Menthol Spray nasal",
  },
  {
    allergyType: "1",
    allergyId: "8037",
    ROUTED_MED_ID: 147053,
    Descr: "Afrin No Drip (oxymetazoline) nasal",
  },
  {
    allergyType: "1",
    allergyId: "48823",
    ROUTED_MED_ID: 11155,
    Descr: "Afrin Saline Nasal Mist nasal",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 12305,
    Descr: "Afrin Sinus (oxymetazoline) nasal",
  },
  {
    allergyType: "0",
    allergyId: "8578",
    ROUTED_MED_ID: 0,
    Descr: "agalsidase alfa",
  },
  {
    allergyType: "0",
    allergyId: "9873",
    ROUTED_MED_ID: 0,
    Descr: "agalsidase beta",
  },
  {
    allergyType: "3",
    allergyId: "1309",
    ROUTED_MED_ID: 0,
    Descr: "AGALSIDASE BETA",
  },
  {
    allergyType: "2",
    allergyId: "51658,54431",
    ROUTED_MED_ID: 75197,
    Descr: "agalsidase beta intravenous",
  },
  {
    allergyType: "1",
    allergyId: "41672,42109,45171",
    ROUTED_MED_ID: 17199,
    Descr: "Agenerase oral",
  },
  {
    allergyType: "1",
    allergyId: "76752",
    ROUTED_MED_ID: 155024,
    Descr: "Aggrastat Concentrate intravenous",
  },
  {
    allergyType: "1",
    allergyId: "39779,43237,64719",
    ROUTED_MED_ID: 7966,
    Descr: "Aggrastat in sodium chloride intravenous",
  },
  {
    allergyType: "1",
    allergyId: "2979",
    ROUTED_MED_ID: 165905,
    Descr: "Agoral (docusate-casanthranol) oral",
  },
  {
    allergyType: "1",
    allergyId: "68487",
    ROUTED_MED_ID: 16988,
    Descr: "Air Salonpas topical",
  },
  {
    allergyType: "1",
    allergyId: "63428",
    ROUTED_MED_ID: 86444,
    Descr: "Air Warming Mask",
  },
  {
    allergyType: "1",
    allergyId: "71403",
    ROUTED_MED_ID: 165060,
    Descr: "Airborne (ascorbate sodium) mucous membrane",
  },
  {
    allergyType: "1",
    allergyId: "71402,71405",
    ROUTED_MED_ID: 165047,
    Descr: "Airborne (ascorbate sodium) oral",
  },
  {
    allergyType: "1",
    allergyId: "81167,81176,81233",
    ROUTED_MED_ID: 179542,
    Descr: "Airborne (ascorbic acid) oral",
  },
  {
    allergyType: "1",
    allergyId: "23835",
    ROUTED_MED_ID: 154227,
    Descr: "AIRS Adult Aerosol Mask",
  },
  {
    allergyType: "1",
    allergyId: "23835",
    ROUTED_MED_ID: 89419,
    Descr: "Airs Pediatric Aerosol Mask",
  },
  {
    allergyType: "1",
    allergyId: "63428",
    ROUTED_MED_ID: 86446,
    Descr: "Airs Pediatric Disposable Mask",
  },
  {
    allergyType: "2",
    allergyId: "69217",
    ROUTED_MED_ID: 160893,
    Descr: "ALA-boswel-ginger-bas-rose-tur-wil topical",
  },
  {
    allergyType: "1",
    allergyId: "45393",
    ROUTED_MED_ID: 19580,
    Descr: "Alamast ophthalmic (eye)",
  },
  {
    allergyType: "1",
    allergyId: "43521",
    ROUTED_MED_ID: 90602,
    Descr: "Albay-Wasp injection",
  },
  {
    allergyType: "1",
    allergyId: "4376",
    ROUTED_MED_ID: 4523,
    Descr: "Albertsons Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "1106",
    ROUTED_MED_ID: 4612,
    Descr: "Albertsons Child Non-ASA Cold oral",
  },
  {
    allergyType: "1",
    allergyId: "4380",
    ROUTED_MED_ID: 4525,
    Descr: "Albertsons Childrens Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "4381",
    ROUTED_MED_ID: 4526,
    Descr: "Albertsons EC Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "3699",
    ROUTED_MED_ID: 4529,
    Descr: "Albertsons Ex St Non-ASA PM oral",
  },
  {
    allergyType: "1",
    allergyId: "16948",
    ROUTED_MED_ID: 4531,
    Descr: "Albertsons Infants Non-Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "4493",
    ROUTED_MED_ID: 4543,
    Descr: "Albertsons Jr St Non-Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 4590,
    Descr: "Albertsons Nasal Spray nasal",
  },
  {
    allergyType: "1",
    allergyId: "1101,1104",
    ROUTED_MED_ID: 4604,
    Descr: "Albertsons Non-ASA Aller Sinus oral",
  },
  {
    allergyType: "1",
    allergyId: "906",
    ROUTED_MED_ID: 20716,
    Descr: "Albertsons Non-ASA Flu Max St oral",
  },
  {
    allergyType: "1",
    allergyId: "1112",
    ROUTED_MED_ID: 20697,
    Descr: "Albertsons Non-Aspirin Sinus oral",
  },
  {
    allergyType: "1",
    allergyId: "8084",
    ROUTED_MED_ID: 4591,
    Descr: "Albertsons Saline Nasal Spray nasal",
  },
  {
    allergyType: "0",
    allergyId: "4951",
    ROUTED_MED_ID: 0,
    Descr: "alclometasone",
  },
  {
    allergyType: "2",
    allergyId: "7636,7637",
    ROUTED_MED_ID: 7910,
    Descr: "alclometasone topical",
  },
  {
    allergyType: "1",
    allergyId: "63390",
    ROUTED_MED_ID: 149672,
    Descr: "Alcohol Gel Base",
  },
  {
    allergyType: "2",
    allergyId: "65458",
    ROUTED_MED_ID: 152803,
    Descr: "alcohol-menth-eugen-pepmint,wintrgrn oils-glyc-ans mouthwash",
  },
  {
    allergyType: "1",
    allergyId: "8068",
    ROUTED_MED_ID: 6669,
    Descr: "Alconefrin 12 nasal",
  },
  {
    allergyType: "1",
    allergyId: "8060,8070",
    ROUTED_MED_ID: 7809,
    Descr: "Alconefrin 25 nasal",
  },
  {
    allergyType: "1",
    allergyId: "8071",
    ROUTED_MED_ID: 7810,
    Descr: "Alconefrin 50 nasal",
  },
  {
    allergyType: "1",
    allergyId: "82591",
    ROUTED_MED_ID: 182265,
    Descr: "Algae Based Calcium oral",
  },
  {
    allergyType: "0",
    allergyId: "3586",
    ROUTED_MED_ID: 0,
    Descr: "alglucerase",
  },
  {
    allergyType: "2",
    allergyId: "15956,19072",
    ROUTED_MED_ID: 8726,
    Descr: "alglucerase intravenous",
  },
  {
    allergyType: "0",
    allergyId: "11335",
    ROUTED_MED_ID: 0,
    Descr: "alglucosidase alfa",
  },
  {
    allergyType: "2",
    allergyId: "60662",
    ROUTED_MED_ID: 144193,
    Descr: "alglucosidase alfa intravenous",
  },
  {
    allergyType: "1",
    allergyId: "2814",
    ROUTED_MED_ID: 6552,
    Descr: "Alka-Seltzer Anti-Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "73478",
    ROUTED_MED_ID: 167783,
    Descr: "Alka-Seltzer Heartburn-Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "69874",
    ROUTED_MED_ID: 170221,
    Descr: "Alka-Seltzer Plus Night (aspirin) oral",
  },
  {
    allergyType: "1",
    allergyId: "81061",
    ROUTED_MED_ID: 179397,
    Descr: "Alkalol Nasal Wash nasal",
  },
  {
    allergyType: "1",
    allergyId: "19196",
    ROUTED_MED_ID: 1367,
    Descr: "Alkeran (as HCl) intravenous",
  },
  {
    allergyType: "1",
    allergyId: "10959",
    ROUTED_MED_ID: 90067,
    Descr: "All Purpose Supply Case",
  },
  {
    allergyType: "1",
    allergyId: "72054",
    ROUTED_MED_ID: 179222,
    Descr: "Aller-Cort nasal",
  },
  {
    allergyType: "1",
    allergyId: "31689,33716,61995",
    ROUTED_MED_ID: 155219,
    Descr: "Aller-Ease oral",
  },
  {
    allergyType: "1",
    allergyId: "73300",
    ROUTED_MED_ID: 172007,
    Descr: "Aller-Flo nasal",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 54217,
    Descr: "Allerest 12 Hour nasal",
  },
  {
    allergyType: "1",
    allergyId: "8039",
    ROUTED_MED_ID: 5613,
    Descr: "Allerest 12 Hour Nasal Spray nasal",
  },
  {
    allergyType: "1",
    allergyId: "8061",
    ROUTED_MED_ID: 54249,
    Descr: "Allerest nasal",
  },
  {
    allergyType: "2",
    allergyId: "71791",
    ROUTED_MED_ID: 166121,
    Descr: "allergen extract,grass pollen-timothy sublingual",
  },
  {
    allergyType: "2",
    allergyId: "64149",
    ROUTED_MED_ID: 150784,
    Descr: "allergenic extract,grass pollen-Bermuda injection",
  },
  {
    allergyType: "2",
    allergyId: "65569",
    ROUTED_MED_ID: 153101,
    Descr: "allergenic extract,grass pollen-June injection",
  },
  {
    allergyType: "2",
    allergyId: "47955",
    ROUTED_MED_ID: 146892,
    Descr: "allergenic extract,grass pollen-meadow fescue injection",
  },
  {
    allergyType: "2",
    allergyId: "47959",
    ROUTED_MED_ID: 146891,
    Descr: "allergenic extract,grass pollen-redtop injection",
  },
  {
    allergyType: "2",
    allergyId: "47960,48685",
    ROUTED_MED_ID: 146330,
    Descr: "allergenic extract,grass pollen-timothy injection",
  },
  {
    allergyType: "2",
    allergyId: "74552,75305,81302,81395",
    ROUTED_MED_ID: 169463,
    Descr: "allergenic extract-Aspergillus fumigatus injection",
  },
  {
    allergyType: "2",
    allergyId: "75507",
    ROUTED_MED_ID: 171045,
    Descr: "allergenic extract-Aspergillus,mixed injection",
  },
  {
    allergyType: "2",
    allergyId: "75306,75389,81289,82183",
    ROUTED_MED_ID: 170731,
    Descr: "allergenic extract-Aureobasidium pullulans injection",
  },
  {
    allergyType: "2",
    allergyId: "76721",
    ROUTED_MED_ID: 172719,
    Descr: "allergenic extract-food-casein percutaneous",
  },
  {
    allergyType: "2",
    allergyId: "84741",
    ROUTED_MED_ID: 186599,
    Descr: "allergenic extract-grass pollen injection",
  },
  {
    allergyType: "2",
    allergyId: "65770",
    ROUTED_MED_ID: 154888,
    Descr: "allergenic extract-grass pollen, orchard grass injection",
  },
  {
    allergyType: "2",
    allergyId: "47958",
    ROUTED_MED_ID: 146894,
    Descr: "allergenic extract-grass pollen, perennial rye injection",
  },
  {
    allergyType: "2",
    allergyId: "74919",
    ROUTED_MED_ID: 170101,
    Descr: "allergenic extract-grass pollen-bahia injection",
  },
  {
    allergyType: "2",
    allergyId: "74647",
    ROUTED_MED_ID: 169629,
    Descr: "allergenic extract-grass pollen-Johnson injection",
  },
  {
    allergyType: "2",
    allergyId: "76369",
    ROUTED_MED_ID: 172168,
    Descr: "allergenic extract-grass pollen-smooth brome injection",
  },
  {
    allergyType: "2",
    allergyId: "75961",
    ROUTED_MED_ID: 171670,
    Descr: "allergenic extract-quack grass pollen injection",
  },
  {
    allergyType: "2",
    allergyId: "74907",
    ROUTED_MED_ID: 170086,
    Descr: "allergenic extract-tree pollen, white ash injection",
  },
  {
    allergyType: "2",
    allergyId: "74570",
    ROUTED_MED_ID: 169494,
    Descr: "allergenic extract-tree pollen-eastern cottonwood injection",
  },
  {
    allergyType: "2",
    allergyId: "40811,42525,43522,45353,45354,45355,48619,62218",
    ROUTED_MED_ID: 7623,
    Descr: "allergenic extract-venom-wasp protein injection",
  },
  {
    allergyType: "1",
    allergyId: "83194",
    ROUTED_MED_ID: 188490,
    Descr: "Allergy Nasal (mometasone) nasal",
  },
  {
    allergyType: "1",
    allergyId: "8037",
    ROUTED_MED_ID: 186272,
    Descr: "Allergy Nasal (oxymetazoline) nasal",
  },
  {
    allergyType: "1",
    allergyId: "11655",
    ROUTED_MED_ID: 161603,
    Descr: "Allergy Relief (clemastine) oral",
  },
  {
    allergyType: "1",
    allergyId: "73300",
    ROUTED_MED_ID: 171763,
    Descr: "Allergy Relief (fluticasone) nasal",
  },
  {
    allergyType: "1",
    allergyId: "27622",
    ROUTED_MED_ID: 92310,
    Descr: "Allergy Relief and Nasal Decongestant oral",
  },
  {
    allergyType: "1",
    allergyId: "1104",
    ROUTED_MED_ID: 55020,
    Descr: "Allergy/Sinus Max Strn W/O Asa oral",
  },
  {
    allergyType: "1",
    allergyId: "1104",
    ROUTED_MED_ID: 16395,
    Descr: "Allergy/Sinus Non-ASA Max St oral",
  },
  {
    allergyType: "1",
    allergyId: "11655",
    ROUTED_MED_ID: 174856,
    Descr: "Allerhist (clemastine) oral",
  },
  {
    allergyType: "0",
    allergyId: "4080",
    ROUTED_MED_ID: 0,
    Descr: "almasilate",
  },
  {
    allergyType: "1",
    allergyId: "5380",
    ROUTED_MED_ID: 62065,
    Descr: "Aloe Vera Elastin topical",
  },
  {
    allergyType: "1",
    allergyId: "5376",
    ROUTED_MED_ID: 17643,
    Descr: "Aloe Vesta 2-in-1 Body Wash topical",
  },
  {
    allergyType: "1",
    allergyId: "5376",
    ROUTED_MED_ID: 20842,
    Descr: "Aloe Vesta 2-n-1 Body Wash topical",
  },
  {
    allergyType: "1",
    allergyId: "5376",
    ROUTED_MED_ID: 5059,
    Descr: "Aloe Vesta Body Wash/Shampoo topical",
  },
  {
    allergyType: "1",
    allergyId: "74443",
    ROUTED_MED_ID: 169302,
    Descr: "AlpaWash",
  },
  {
    allergyType: "3",
    allergyId: "1082",
    ROUTED_MED_ID: 0,
    Descr: "ALPHA D-GALACTOSIDASE",
  },
  {
    allergyType: "3",
    allergyId: "1083",
    ROUTED_MED_ID: 0,
    Descr: "ALPHA GLUCOSIDASE",
  },
  {
    allergyType: "0",
    allergyId: "10674",
    ROUTED_MED_ID: 0,
    Descr: "alpha glucosidase",
  },
  {
    allergyType: "0",
    allergyId: "3425",
    ROUTED_MED_ID: 0,
    Descr: "alpha-1-proteinase inhibitor",
  },
  {
    allergyType: "2",
    allergyId: "11700,11701,66706,78055,85543,85544",
    ROUTED_MED_ID: 7998,
    Descr: "alpha-1-proteinase inhibitor (human) intravenous",
  },
  {
    allergyType: "0",
    allergyId: "5674",
    ROUTED_MED_ID: 0,
    Descr: "alpha-amylase",
  },
  {
    allergyType: "0",
    allergyId: "7842",
    ROUTED_MED_ID: 0,
    Descr: "alpha-D-galactosidase",
  },
  {
    allergyType: "2",
    allergyId: "43640,43641,51394,66168,69260,80862,82677,83517",
    ROUTED_MED_ID: 6198,
    Descr: "alpha-d-galactosidase oral",
  },
  {
    allergyType: "1",
    allergyId: "44673",
    ROUTED_MED_ID: 16386,
    Descr: "AlphaSoft topical",
  },
  {
    allergyType: "1",
    allergyId: "29186,29187,29188,29189",
    ROUTED_MED_ID: 7744,
    Descr: "Alprostadil (Vasodilator) urethral",
  },
  {
    allergyType: "1",
    allergyId: "75385",
    ROUTED_MED_ID: 170886,
    Descr: "Altaderm Cream Base topical",
  },
  {
    allergyType: "1",
    allergyId: "8084",
    ROUTED_MED_ID: 8983,
    Descr: "Altamist nasal",
  },
  {
    allergyType: "1",
    allergyId: "3393",
    ROUTED_MED_ID: 7709,
    Descr: "Altaseptic mucous membrane",
  },
  {
    allergyType: "0",
    allergyId: "2074",
    ROUTED_MED_ID: 0,
    Descr: "alteplase",
  },
  {
    allergyType: "2",
    allergyId: "48447",
    ROUTED_MED_ID: 21807,
    Descr: "alteplase intra-catheter",
  },
  {
    allergyType: "2",
    allergyId: "6508,16922",
    ROUTED_MED_ID: 8727,
    Descr: "alteplase intravenous",
  },
  {
    allergyType: "0",
    allergyId: "10514",
    ROUTED_MED_ID: 0,
    Descr: "aluminized plastic",
  },
  {
    allergyType: "0",
    allergyId: "1594",
    ROUTED_MED_ID: 0,
    Descr: "aluminum aspirin",
  },
  {
    allergyType: "0",
    allergyId: "1124",
    ROUTED_MED_ID: 0,
    Descr: "aluminum carbonate,basic",
  },
  {
    allergyType: "1",
    allergyId: "5478",
    ROUTED_MED_ID: 62104,
    Descr: "Aluminum Paste topical",
  },
  {
    allergyType: "1",
    allergyId: "13227",
    ROUTED_MED_ID: 4166,
    Descr: "Aluminum Potassium Sulfate",
  },
  {
    allergyType: "1",
    allergyId: "77536",
    ROUTED_MED_ID: 173859,
    Descr: "Alzair nasal",
  },
  {
    allergyType: "1",
    allergyId: "10926",
    ROUTED_MED_ID: 164523,
    Descr: "Amber Glass Bottle",
  },
  {
    allergyType: "1",
    allergyId: "10923",
    ROUTED_MED_ID: 172417,
    Descr: "Amber Glass Vial",
  },
  {
    allergyType: "1",
    allergyId: "5693",
    ROUTED_MED_ID: 10428,
    Descr: "Amber Mouthwash mucous membrane",
  },
  {
    allergyType: "1",
    allergyId: "23852",
    ROUTED_MED_ID: 155050,
    Descr: "American Star Washcloths topical",
  },
  {
    allergyType: "1",
    allergyId: "51213",
    ROUTED_MED_ID: 64363,
    Descr: "Amerigel Wound Wash topical",
  },
  {
    allergyType: "1",
    allergyId: "43638",
    ROUTED_MED_ID: 152127,
    Descr: "Ameriwash Hand Soap topical",
  },
  {
    allergyType: "0",
    allergyId: "9054",
    ROUTED_MED_ID: 0,
    Descr: "amine oxidase",
  },
  {
    allergyType: "2",
    allergyId: "1824",
    ROUTED_MED_ID: 162382,
    Descr: "amino acids-ascorbic acid-minerals oral",
  },
  {
    allergyType: "2",
    allergyId: "36885",
    ROUTED_MED_ID: 76530,
    Descr: "amino acids-mag aspart-B cplx oral",
  },
  {
    allergyType: "1",
    allergyId: "24696",
    ROUTED_MED_ID: 4268,
    Descr: "Aminobenzoate Potassium",
  },
  {
    allergyType: "1",
    allergyId: "2079,2081,2082",
    ROUTED_MED_ID: 17119,
    Descr: "Aminobenzoate Potassium oral",
  },
  {
    allergyType: "1",
    allergyId: "1847,1863",
    ROUTED_MED_ID: 4034,
    Descr: "Aminostasis oral",
  },
  {
    allergyType: "2",
    allergyId:
      "53689,53690,53691,53692,53693,53694,53695,53696,58432,58433,58434",
    ROUTED_MED_ID: 78636,
    Descr: "amlodipine-atorvastatin oral",
  },
  {
    allergyType: "2",
    allergyId: "60384",
    ROUTED_MED_ID: 95061,
    Descr: "ammonium and potassium iodides topical",
  },
  {
    allergyType: "2",
    allergyId: "58010,64471",
    ROUTED_MED_ID: 91623,
    Descr: "ammonium lactate-sodium lactate-potassium lactate topical",
  },
  {
    allergyType: "1",
    allergyId: "24663",
    ROUTED_MED_ID: 6647,
    Descr: "Ammonium Phosphate Dibasic",
  },
  {
    allergyType: "2",
    allergyId: "13037",
    ROUTED_MED_ID: 76534,
    Descr: "ammonium-potassium-sodium oral",
  },
  {
    allergyType: "1",
    allergyId: "8992,25898,26720",
    ROUTED_MED_ID: 74926,
    Descr: "Amox Tr-Potassium Clavulanate oral",
  },
  {
    allergyType: "2",
    allergyId: "71954",
    ROUTED_MED_ID: 165694,
    Descr: "amoxicillin-potassium clavulanate (bulk)",
  },
  {
    allergyType: "2",
    allergyId:
      "8989,8990,8991,8992,8993,8994,24668,25898,26718,26719,26720,48449,50991",
    ROUTED_MED_ID: 1922,
    Descr: "amoxicillin-potassium clavulanate oral",
  },
  {
    allergyType: "1",
    allergyId: "5256",
    ROUTED_MED_ID: 91870,
    Descr: "Amphadase injection",
  },
  {
    allergyType: "3",
    allergyId: "379",
    ROUTED_MED_ID: 0,
    Descr: "AMYLASE",
  },
  {
    allergyType: "0",
    allergyId: "1137",
    ROUTED_MED_ID: 0,
    Descr: "amylase",
  },
  {
    allergyType: "1",
    allergyId: "43570",
    ROUTED_MED_ID: 17569,
    Descr: "Amylase Concentrate-HP oral",
  },
  {
    allergyType: "2",
    allergyId: "74828",
    ROUTED_MED_ID: 145040,
    Descr: "amylase-cellulase-lipase-maltase-protease-lactase-inver oral",
  },
  {
    allergyType: "2",
    allergyId: "2788,58600",
    ROUTED_MED_ID: 92532,
    Descr: "amylase-lip-prot-cell-ptolox-hyoscy oral",
  },
  {
    allergyType: "2",
    allergyId: "28204",
    ROUTED_MED_ID: 159494,
    Descr: "amylase-lipase-lactase-bromelains-papain oral",
  },
  {
    allergyType: "2",
    allergyId: "2789,2790,2791",
    ROUTED_MED_ID: 64171,
    Descr: "amylase-lipase-protease-cellulase oral",
  },
  {
    allergyType: "2",
    allergyId: "79698",
    ROUTED_MED_ID: 177188,
    Descr: "amylase-protease-papain-papaya oral",
  },
  {
    allergyType: "0",
    allergyId: "19259",
    ROUTED_MED_ID: 0,
    Descr: "anacaulase-bcdb",
  },
  {
    allergyType: "2",
    allergyId: "84262,85641",
    ROUTED_MED_ID: 185693,
    Descr: "anacaulase-bcdb topical",
  },
  {
    allergyType: "1",
    allergyId: "13035",
    ROUTED_MED_ID: 86482,
    Descr: "Anaclasine oral",
  },
  {
    allergyType: "1",
    allergyId: "8060",
    ROUTED_MED_ID: 54246,
    Descr: "Anahist nasal",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 170240,
    Descr: "Analgesic (aspirin/caffeine) oral",
  },
  {
    allergyType: "1",
    allergyId: "67782",
    ROUTED_MED_ID: 156917,
    Descr: "Anascorp intravenous",
  },
  {
    allergyType: "1",
    allergyId: "67440",
    ROUTED_MED_ID: 168215,
    Descr: "Anasept irrigation",
  },
  {
    allergyType: "1",
    allergyId: "67440",
    ROUTED_MED_ID: 156004,
    Descr: "Anasept Skin-Wound Cleanser irrigation",
  },
  {
    allergyType: "1",
    allergyId: "66034",
    ROUTED_MED_ID: 153613,
    Descr: "Anasept topical",
  },
  {
    allergyType: "1",
    allergyId: "47546",
    ROUTED_MED_ID: 5408,
    Descr: "Anaspaz oral",
  },
  {
    allergyType: "1",
    allergyId: "4855",
    ROUTED_MED_ID: 56707,
    Descr: "Anaspaz-PB oral",
  },
  {
    allergyType: "1",
    allergyId: "76647",
    ROUTED_MED_ID: 172649,
    Descr: "Anastia topical",
  },
  {
    allergyType: "0",
    allergyId: "5094",
    ROUTED_MED_ID: 0,
    Descr: "anastrozole",
  },
  {
    allergyType: "2",
    allergyId: "62983",
    ROUTED_MED_ID: 148866,
    Descr: "anastrozole (bulk)",
  },
  {
    allergyType: "2",
    allergyId: "24515",
    ROUTED_MED_ID: 1555,
    Descr: "anastrozole oral",
  },
  {
    allergyType: "1",
    allergyId: "3152",
    ROUTED_MED_ID: 53198,
    Descr: "Ando Long Lasting intramuscular",
  },
  {
    allergyType: "1",
    allergyId: "8037,8039",
    ROUTED_MED_ID: 54220,
    Descr: "Anefrin nasal",
  },
  {
    allergyType: "1",
    allergyId: "10643",
    ROUTED_MED_ID: 62814,
    Descr: "Anesthesia Ext Set,Bulb Flasht",
  },
  {
    allergyType: "1",
    allergyId: "423",
    ROUTED_MED_ID: 86493,
    Descr: "Angio-Pak with Vascoray injection",
  },
  {
    allergyType: "1",
    allergyId: "66543",
    ROUTED_MED_ID: 154470,
    Descr: "Anhydrous Base topical",
  },
  {
    allergyType: "1",
    allergyId: "63929",
    ROUTED_MED_ID: 148173,
    Descr: "Animas 2020 Insulin Pump",
  },
  {
    allergyType: "1",
    allergyId: "73827",
    ROUTED_MED_ID: 168308,
    Descr: "Animas Vibe",
  },
  {
    allergyType: "0",
    allergyId: "3527",
    ROUTED_MED_ID: 0,
    Descr: "anistreplase",
  },
  {
    allergyType: "2",
    allergyId: "13659",
    ROUTED_MED_ID: 7324,
    Descr: "anistreplase intravenous",
  },
  {
    allergyType: "1",
    allergyId: "4770,4777",
    ROUTED_MED_ID: 56645,
    Descr: "Anitspasmatic oral",
  },
  {
    allergyType: "1",
    allergyId: "48328",
    ROUTED_MED_ID: 171106,
    Descr: "Antacid Anti-Gas (calcium carb-simeth) oral",
  },
  {
    allergyType: "1",
    allergyId: "22348",
    ROUTED_MED_ID: 171107,
    Descr: "Antacid Anti-Gas (magaldrate-simethicone) oral",
  },
  {
    allergyType: "1",
    allergyId: "2706",
    ROUTED_MED_ID: 56579,
    Descr: "Antacid Anti-Gas Double Str oral",
  },
  {
    allergyType: "1",
    allergyId: "2706",
    ROUTED_MED_ID: 15808,
    Descr: "Antacid Anti-Gas DS oral",
  },
  {
    allergyType: "1",
    allergyId: "2701,2706",
    ROUTED_MED_ID: 15806,
    Descr: "Antacid Anti-Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "2706",
    ROUTED_MED_ID: 21206,
    Descr: "Antacid Fast Acting oral",
  },
  {
    allergyType: "1",
    allergyId: "2700",
    ROUTED_MED_ID: 20630,
    Descr: "Antacid Plus Anti-Gas Ext Str oral",
  },
  {
    allergyType: "1",
    allergyId: "2700,2701,2706",
    ROUTED_MED_ID: 511,
    Descr: "Antacid Plus Anti-Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "2701,2706,2708",
    ROUTED_MED_ID: 15959,
    Descr: "Antacid-Anti Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "2705,2706",
    ROUTED_MED_ID: 56568,
    Descr: "Antacid-Antigas II oral",
  },
  {
    allergyType: "1",
    allergyId: "2701",
    ROUTED_MED_ID: 56513,
    Descr: "Antacid-Antigas oral",
  },
  {
    allergyType: "1",
    allergyId: "2701,2706",
    ROUTED_MED_ID: 157744,
    Descr: "Antacid-Antigas oral",
  },
  {
    allergyType: "1",
    allergyId: "2705",
    ROUTED_MED_ID: 56569,
    Descr: "Antacid/Antigas Ii oral",
  },
  {
    allergyType: "1",
    allergyId: "2708",
    ROUTED_MED_ID: 56490,
    Descr: "Antacid/Antigas oral",
  },
  {
    allergyType: "1",
    allergyId: "85847",
    ROUTED_MED_ID: 188382,
    Descr: "Anthrasil (National Stockpile) intravenous",
  },
  {
    allergyType: "1",
    allergyId: "39197",
    ROUTED_MED_ID: 22039,
    Descr: "Anti Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "45",
    ROUTED_MED_ID: 55991,
    Descr: "Anti-Asthma oral",
  },
  {
    allergyType: "1",
    allergyId: "48990",
    ROUTED_MED_ID: 147755,
    Descr: "Anti-Diarrheal (loperamide) - Anti-Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "2814,39197",
    ROUTED_MED_ID: 14319,
    Descr: "Anti-Gas Maximum Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "2814,2815,2821,39197,40944,66168",
    ROUTED_MED_ID: 17349,
    Descr: "Anti-Gas oral",
  },
  {
    allergyType: "1",
    allergyId: "40944",
    ROUTED_MED_ID: 93598,
    Descr: "Anti-Gas Ultra Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "2821",
    ROUTED_MED_ID: 3808,
    Descr: "Anti-Gas/80 oral",
  },
  {
    allergyType: "1",
    allergyId: "4773,4777",
    ROUTED_MED_ID: 13769,
    Descr: "Anti-Spas oral",
  },
  {
    allergyType: "2",
    allergyId: "63074",
    ROUTED_MED_ID: 167543,
    Descr: "antihemophilic factor VIII (plasma/albumen free) intravenous",
  },
  {
    allergyType: "1",
    allergyId: "1151",
    ROUTED_MED_ID: 54780,
    Descr: "Antihist/Nasal oral",
  },
  {
    allergyType: "1",
    allergyId: "1150,1151,1154",
    ROUTED_MED_ID: 3426,
    Descr: "Antihistamine Nasal Decongest oral",
  },
  {
    allergyType: "1",
    allergyId: "1154",
    ROUTED_MED_ID: 54726,
    Descr: "Antihistamine/Nasal Decongest oral",
  },
  {
    allergyType: "2",
    allergyId: "13709",
    ROUTED_MED_ID: 5696,
    Descr: "antimony potassium tartrate (bulk)",
  },
  {
    allergyType: "1",
    allergyId: "73059",
    ROUTED_MED_ID: 167450,
    Descr: "Antioxidant Formula (selenium yeast) oral",
  },
  {
    allergyType: "1",
    allergyId: "5693",
    ROUTED_MED_ID: 276,
    Descr: "Antiseptic Mouthwash",
  },
  {
    allergyType: "1",
    allergyId: "5693",
    ROUTED_MED_ID: 3410,
    Descr: "Antiseptic Mouthwash-Gargle mucous membrane",
  },
  {
    allergyType: "1",
    allergyId: "48804",
    ROUTED_MED_ID: 22469,
    Descr: "Antiseptic Perineal Wash II topical",
  },
  {
    allergyType: "1",
    allergyId: "4922",
    ROUTED_MED_ID: 8999,
    Descr: "Antispas intramuscular",
  },
  {
    allergyType: "1",
    allergyId: "4773",
    ROUTED_MED_ID: 56694,
    Descr: "Antispasmatic oral",
  },
  {
    allergyType: "1",
    allergyId: "4773",
    ROUTED_MED_ID: 8466,
    Descr: "Antispasmodic Compound oral",
  },
  {
    allergyType: "1",
    allergyId: "4784",
    ROUTED_MED_ID: 19064,
    Descr: "Antispasmodic Extentabs oral",
  },
  {
    allergyType: "1",
    allergyId: "4770,4773,4777,4787",
    ROUTED_MED_ID: 14739,
    Descr: "Antispasmodic oral",
  },
  {
    allergyType: "1",
    allergyId: "4777",
    ROUTED_MED_ID: 56685,
    Descr: "Antispasmodil oral",
  },
  {
    allergyType: "1",
    allergyId: "4777",
    ROUTED_MED_ID: 56674,
    Descr: "Antispasmotic oral",
  },
  {
    allergyType: "0",
    allergyId: "3638",
    ROUTED_MED_ID: 0,
    Descr: "antithrombin III (human plasma derived)",
  },
  {
    allergyType: "0",
    allergyId: "11680",
    ROUTED_MED_ID: 0,
    Descr: "antivenom, eastern green mamba",
  },
  {
    allergyType: "0",
    allergyId: "19202",
    ROUTED_MED_ID: 0,
    Descr: "antivenom,Bothrops asper",
  },
  {
    allergyType: "1",
    allergyId: "4494",
    ROUTED_MED_ID: 57603,
    Descr: "Apap Non-Aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "34200",
    ROUTED_MED_ID: 4868,
    Descr: "Aphthasol mucous membrane",
  },
  {
    allergyType: "1",
    allergyId: "72948",
    ROUTED_MED_ID: 167143,
    Descr: "Apothesil Base topical",
  },
  {
    allergyType: "0",
    allergyId: "15411",
    ROUTED_MED_ID: 0,
    Descr: "apremilast",
  },
  {
    allergyType: "2",
    allergyId: "72075,72076,73370",
    ROUTED_MED_ID: 165850,
    Descr: "apremilast oral",
  },
  {
    allergyType: "1",
    allergyId: "24489",
    ROUTED_MED_ID: 18065,
    Descr: "Aqua Glycolic Astringent topical",
  },
  {
    allergyType: "1",
    allergyId: "8084",
    ROUTED_MED_ID: 54269,
    Descr: "Aqua-Sal nasal",
  },
  {
    allergyType: "1",
    allergyId: "8515",
    ROUTED_MED_ID: 12070,
    Descr: "Aquabase topical",
  },
  {
    allergyType: "1",
    allergyId: "11082",
    ROUTED_MED_ID: 86507,
    Descr: "Aquaflex Ultrasound Gel Pad",
  },
  {
    allergyType: "1",
    allergyId: "15234,15235",
    ROUTED_MED_ID: 174765,
    Descr: "Aquaphor Baby Diaper Rash topical",
  },
  {
    allergyType: "1",
    allergyId: "312",
    ROUTED_MED_ID: 53645,
    Descr: "Aquaserp 25 oral",
  },
  {
    allergyType: "1",
    allergyId: "313",
    ROUTED_MED_ID: 53660,
    Descr: "Aquaserp 50 oral",
  },
  {
    allergyType: "1",
    allergyId: "22918,22925,37049",
    ROUTED_MED_ID: 77803,
    Descr: "Aquasite Impregnated Dressing topical",
  },
  {
    allergyType: "1",
    allergyId: "22918,22925,37049",
    ROUTED_MED_ID: 77054,
    Descr: "Aquasite Impregnated Gauze topical",
  },
  {
    allergyType: "1",
    allergyId: "18758,30017",
    ROUTED_MED_ID: 15281,
    Descr: "Aquasite ophthalmic (eye)",
  },
  {
    allergyType: "1",
    allergyId: "22918,22925,22927,23554",
    ROUTED_MED_ID: 77125,
    Descr: "Aquasite Sheet Dressing topical",
  },
  {
    allergyType: "1",
    allergyId: "58846",
    ROUTED_MED_ID: 11118,
    Descr: "Aquasol A intramuscular",
  },
  {
    allergyType: "1",
    allergyId: "2038,2039,2041",
    ROUTED_MED_ID: 8607,
    Descr: "Aquasol A oral",
  },
  {
    allergyType: "1",
    allergyId: "2211,2214,2219",
    ROUTED_MED_ID: 5290,
    Descr: "Aquasol E (d-alpha tocopherol) oral",
  },
  {
    allergyType: "1",
    allergyId: "11043",
    ROUTED_MED_ID: 86515,
    Descr: "Aquasonic 100 Sterile topical",
  },
  {
    allergyType: "1",
    allergyId: "11041",
    ROUTED_MED_ID: 86514,
    Descr: "Aquasonic 100 topical",
  },
  {
    allergyType: "1",
    allergyId: "22916,22919",
    ROUTED_MED_ID: 86517,
    Descr: "Aquasorb Border topical",
  },
  {
    allergyType: "1",
    allergyId: "22916,22919,22920,22921,22928",
    ROUTED_MED_ID: 86516,
    Descr: "Aquasorb Hydrogel topical",
  },
  {
    allergyType: "1",
    allergyId: "1218",
    ROUTED_MED_ID: 186871,
    Descr: "Aquastat 0.9% sodium chloride injection",
  },
  {
    allergyType: "1",
    allergyId: "1218",
    ROUTED_MED_ID: 186872,
    Descr: "Aquastat SFR 0.9% sodium chloride injection",
  },
  {
    allergyType: "1",
    allergyId: "11700,11701",
    ROUTED_MED_ID: 74919,
    Descr: "Aralast intravenous",
  },
  {
    allergyType: "1",
    allergyId: "11700,11701",
    ROUTED_MED_ID: 150128,
    Descr: "Aralast NP intravenous",
  },
  {
    allergyType: "1",
    allergyId: "2791",
    ROUTED_MED_ID: 90576,
    Descr: "Arco-Lase oral",
  },
  {
    allergyType: "1",
    allergyId: "44186",
    ROUTED_MED_ID: 17966,
    Descr: "Aromasin oral",
  },
  {
    allergyType: "2",
    allergyId: "60636",
    ROUTED_MED_ID: 144213,
    Descr: "aromatic cascara fluid extract (bulk) oral",
  },
  {
    allergyType: "1",
    allergyId: "8073",
    ROUTED_MED_ID: 76676,
    Descr: "Aromatic Inhalants nasal",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 149238,
    Descr: "Arthritis Pain Relief (ASA-aaffeine) oral",
  },
  {
    allergyType: "1",
    allergyId: "4381,4383,27885",
    ROUTED_MED_ID: 57415,
    Descr: "Arthritis Pain Relief (Aspirin) oral",
  },
  {
    allergyType: "0",
    allergyId: "10471",
    ROUTED_MED_ID: 0,
    Descr: "artificial plasticizer",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 57691,
    Descr: "As-Caff oral",
  },
  {
    allergyType: "1",
    allergyId: "4338,27884",
    ROUTED_MED_ID: 11215,
    Descr: "ASA Buff (Mag Carb-Al Glyc) oral",
  },
  {
    allergyType: "2",
    allergyId: "4341",
    ROUTED_MED_ID: 9855,
    Descr: "ASA-acetaminophen-caffeine-calcium oral",
  },
  {
    allergyType: "2",
    allergyId: "4340",
    ROUTED_MED_ID: 89280,
    Descr: "ASA-acetaminophen-caffeine-potassium oral",
  },
  {
    allergyType: "2",
    allergyId: "4323,57728,57729,57730",
    ROUTED_MED_ID: 32843,
    Descr: "ASA-acetaminophen-salicylate-caffeine oral",
  },
  {
    allergyType: "1",
    allergyId: "4323",
    ROUTED_MED_ID: 22859,
    Descr: "ASA-APAP-Salicyl-Caff oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 1524,
    Descr: "ASA/Extra Strength Antacid oral",
  },
  {
    allergyType: "1",
    allergyId: "53882",
    ROUTED_MED_ID: 152452,
    Descr: "Asacol HD oral",
  },
  {
    allergyType: "1",
    allergyId: "15237",
    ROUTED_MED_ID: 9006,
    Descr: "Asacol oral",
  },
  {
    allergyType: "2",
    allergyId: "8412",
    ROUTED_MED_ID: 20274,
    Descr: "asafetida",
  },
  {
    allergyType: "0",
    allergyId: "2412",
    ROUTED_MED_ID: 0,
    Descr: "asafetida",
  },
  {
    allergyType: "2",
    allergyId: "8413",
    ROUTED_MED_ID: 1018,
    Descr: "asafetida oral",
  },
  {
    allergyType: "1",
    allergyId: "8412",
    ROUTED_MED_ID: 20238,
    Descr: "Asafoetida",
  },
  {
    allergyType: "1",
    allergyId: "8413",
    ROUTED_MED_ID: 1039,
    Descr: "Asafoetida oral",
  },
  {
    allergyType: "1",
    allergyId: "68900",
    ROUTED_MED_ID: 160394,
    Descr: "ASC Lotionized Cleanser topical",
  },
  {
    allergyType: "1",
    allergyId: "23161",
    ROUTED_MED_ID: 148195,
    Descr: "Asc Lotionized Soap topical",
  },
  {
    allergyType: "1",
    allergyId: "4399",
    ROUTED_MED_ID: 57702,
    Descr: "Ascaphen oral",
  },
  {
    allergyType: "1",
    allergyId: "2894",
    ROUTED_MED_ID: 56034,
    Descr: "Ascarel oral",
  },
  {
    allergyType: "1",
    allergyId: "80474",
    ROUTED_MED_ID: 178327,
    Descr: "Asceniv intravenous",
  },
  {
    allergyType: "1",
    allergyId: "62133",
    ROUTED_MED_ID: 64410,
    Descr: "Ascensia Autodisc",
  },
  {
    allergyType: "1",
    allergyId: "62059",
    ROUTED_MED_ID: 77713,
    Descr: "Ascensia Autodisc Test",
  },
  {
    allergyType: "1",
    allergyId: "62060",
    ROUTED_MED_ID: 75960,
    Descr: "Ascensia Breeze",
  },
  {
    allergyType: "1",
    allergyId: "62060",
    ROUTED_MED_ID: 147056,
    Descr: "Ascensia Breeze 2",
  },
  {
    allergyType: "1",
    allergyId: "62135",
    ROUTED_MED_ID: 147057,
    Descr: "Ascensia Breeze 2",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 92857,
    Descr: "Ascensia BRIO",
  },
  {
    allergyType: "1",
    allergyId: "19549,62135",
    ROUTED_MED_ID: 78217,
    Descr: "Ascensia Contour",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 64407,
    Descr: "Ascensia Dex2",
  },
  {
    allergyType: "1",
    allergyId: "62133",
    ROUTED_MED_ID: 64409,
    Descr: "Ascensia Elite",
  },
  {
    allergyType: "1",
    allergyId: "62136",
    ROUTED_MED_ID: 163256,
    Descr: "Ascensia Elite Normal Control",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 77714,
    Descr: "Ascensia Elite Test",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 64430,
    Descr: "Ascensia Elite Test in vitro",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 64408,
    Descr: "Ascensia Elite XL",
  },
  {
    allergyType: "1",
    allergyId: "6373,62133",
    ROUTED_MED_ID: 78218,
    Descr: "Ascensia Microfill",
  },
  {
    allergyType: "1",
    allergyId: "62136",
    ROUTED_MED_ID: 163253,
    Descr: "Ascensia Microfill Normal Control",
  },
  {
    allergyType: "0",
    allergyId: "18882",
    ROUTED_MED_ID: 0,
    Descr: "asciminib",
  },
  {
    allergyType: "2",
    allergyId: "82783,82784",
    ROUTED_MED_ID: 182620,
    Descr: "asciminib oral",
  },
  {
    allergyType: "1",
    allergyId: "67893,67895",
    ROUTED_MED_ID: 158843,
    Descr: "Asclera intravenous",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 58242,
    Descr: "Asco-Caps-500 oral",
  },
  {
    allergyType: "1",
    allergyId: "2144",
    ROUTED_MED_ID: 58294,
    Descr: "Asco-Tabs-1000 oral",
  },
  {
    allergyType: "1",
    allergyId: "2133",
    ROUTED_MED_ID: 58337,
    Descr: "Ascocid",
  },
  {
    allergyType: "1",
    allergyId: "12014,22656",
    ROUTED_MED_ID: 58343,
    Descr: "Ascocid Iso-Ph oral",
  },
  {
    allergyType: "1",
    allergyId: "2134",
    ROUTED_MED_ID: 58339,
    Descr: "Ascocid oral",
  },
  {
    allergyType: "1",
    allergyId: "2100",
    ROUTED_MED_ID: 86536,
    Descr: "Ascocid-1000 oral",
  },
  {
    allergyType: "1",
    allergyId: "2148",
    ROUTED_MED_ID: 58263,
    Descr: "Ascocid-250 oral",
  },
  {
    allergyType: "1",
    allergyId: "2151",
    ROUTED_MED_ID: 58279,
    Descr: "Ascocid-500 oral",
  },
  {
    allergyType: "1",
    allergyId: "2100",
    ROUTED_MED_ID: 86537,
    Descr: "Ascocid-500-D oral",
  },
  {
    allergyType: "1",
    allergyId: "4120",
    ROUTED_MED_ID: 57853,
    Descr: "Ascomp W/Codeine # 3 oral",
  },
  {
    allergyType: "1",
    allergyId: "4120",
    ROUTED_MED_ID: 32618,
    Descr: "Ascomp with Codeine oral",
  },
  {
    allergyType: "1",
    allergyId: "4120",
    ROUTED_MED_ID: 22651,
    Descr: "Ascomp-Codeine oral",
  },
  {
    allergyType: "1",
    allergyId: "77810",
    ROUTED_MED_ID: 175008,
    Descr: "Ascor intravenous",
  },
  {
    allergyType: "1",
    allergyId: "2132",
    ROUTED_MED_ID: 76871,
    Descr: "Ascor L 500 injection",
  },
  {
    allergyType: "1",
    allergyId: "2132",
    ROUTED_MED_ID: 146378,
    Descr: "Ascor L NC injection",
  },
  {
    allergyType: "1",
    allergyId: "1969",
    ROUTED_MED_ID: 86538,
    Descr: "Ascor-B-Sol in dextrose 5 % intravenous",
  },
  {
    allergyType: "2",
    allergyId: "44107",
    ROUTED_MED_ID: 76717,
    Descr: "ascorbate calc-panthenic acid oral",
  },
  {
    allergyType: "2",
    allergyId: "2115,13636,16871,66409",
    ROUTED_MED_ID: 10417,
    Descr: "ascorbate calcium (vitamin C) oral",
  },
  {
    allergyType: "2",
    allergyId: "22513",
    ROUTED_MED_ID: 7240,
    Descr: "ascorbate calcium (vitamin C)(bulk)",
  },
  {
    allergyType: "2",
    allergyId: "84266",
    ROUTED_MED_ID: 185699,
    Descr: "ascorbate calcium-ascorbyl palmitate oral",
  },
  {
    allergyType: "2",
    allergyId: "43734,43735,45271,69749,84281",
    ROUTED_MED_ID: 64365,
    Descr: "ascorbate calcium-bioflavonoid oral",
  },
  {
    allergyType: "2",
    allergyId: "66220",
    ROUTED_MED_ID: 153916,
    Descr: "ascorbate calcium-calcium pantothen-quercet oral",
  },
  {
    allergyType: "2",
    allergyId: "66218",
    ROUTED_MED_ID: 153914,
    Descr: "ascorbate calcium-multivit-min oral",
  },
  {
    allergyType: "2",
    allergyId: "23478",
    ROUTED_MED_ID: 64370,
    Descr: "ascorbate calcium-rutin-hesperidin-bioflavonoids oral",
  },
  {
    allergyType: "2",
    allergyId: "45225,45226",
    ROUTED_MED_ID: 76445,
    Descr: "ascorbate sod-zinc-echinacea oral",
  },
  {
    allergyType: "2",
    allergyId: "2121,24020,24057",
    ROUTED_MED_ID: 5819,
    Descr: "ascorbate sodium (vitamin C) (bulk)",
  },
  {
    allergyType: "2",
    allergyId: "2119,2120",
    ROUTED_MED_ID: 4150,
    Descr: "ascorbate sodium (vitamin C) injection",
  },
  {
    allergyType: "0",
    allergyId: "1010",
    ROUTED_MED_ID: 0,
    Descr: "ascorbic acid",
  },
  {
    allergyType: "2",
    allergyId: "65037",
    ROUTED_MED_ID: 152135,
    Descr: "ascorbic acid (vit C)-multivitamin with minerals no.18 oral",
  },
  {
    allergyType: "2",
    allergyId: "2125,2129,2131,2132,15980",
    ROUTED_MED_ID: 14453,
    Descr: "ascorbic acid (vitamin C) injection",
  },
  {
    allergyType: "2",
    allergyId: "77810",
    ROUTED_MED_ID: 174240,
    Descr: "ascorbic acid (vitamin C) intravenous",
  },
  {
    allergyType: "2",
    allergyId: "70680",
    ROUTED_MED_ID: 163629,
    Descr: "ascorbic acid (vitamin C) mucous membrane",
  },
  {
    allergyType: "2",
    allergyId:
      "2122,2124,2134,2135,2136,2138,2139,2142,2143,2144,2145,2147,2148,2151,2152,2153,2154,2155,2156,2157,2160,2161,2162,2163,2165,2166,2167,11723,13154,14495,15167,15650,44083,48508,51815,53216,79387,82852",
    ROUTED_MED_ID: 322,
    Descr: "ascorbic acid (vitamin C) oral",
  },
  {
    allergyType: "2",
    allergyId: "2133,24018,68586",
    ROUTED_MED_ID: 93172,
    Descr: "ascorbic acid (vitamin C)(bulk)",
  },
  {
    allergyType: "2",
    allergyId: "68762",
    ROUTED_MED_ID: 159973,
    Descr: "ascorbic acid (vitamin C)-vit E-selenium-herbal no.191 oral",
  },
  {
    allergyType: "2",
    allergyId: "12014,12015",
    ROUTED_MED_ID: 12094,
    Descr: "ascorbic acid buffered oral",
  },
  {
    allergyType: "1",
    allergyId: "2133",
    ROUTED_MED_ID: 58338,
    Descr: "Ascorbic Acid FCC",
  },
  {
    allergyType: "2",
    allergyId: "15027,84859",
    ROUTED_MED_ID: 63443,
    Descr: "ascorbic acid with minerals oral",
  },
  {
    allergyType: "1",
    allergyId: "2144,2148,2151",
    ROUTED_MED_ID: 77608,
    Descr: "Ascorbic Acid with Rose Hips oral",
  },
  {
    allergyType: "2",
    allergyId: "68619,69342,77198",
    ROUTED_MED_ID: 159646,
    Descr: "ascorbic acid-ascorbate calcium oral",
  },
  {
    allergyType: "2",
    allergyId: "66207",
    ROUTED_MED_ID: 153896,
    Descr: "ascorbic acid-ascorbate calcium-ascorbate sod oral",
  },
  {
    allergyType: "2",
    allergyId: "43642,43744,43747,78440,85035",
    ROUTED_MED_ID: 63684,
    Descr: "ascorbic acid-ascorbate sodium (vitamin C) oral",
  },
  {
    allergyType: "2",
    allergyId: "83315",
    ROUTED_MED_ID: 184007,
    Descr: "ascorbic acid-ascorbate sodium-elderberry fruit oral",
  },
  {
    allergyType: "2",
    allergyId: "76883",
    ROUTED_MED_ID: 172943,
    Descr: "ascorbic acid-ascorbate sodium-zinc gluconate and oxide oral",
  },
  {
    allergyType: "2",
    allergyId: "2105,2106,2107,28057,28058,37064,43599,64691,69830,82242",
    ROUTED_MED_ID: 63545,
    Descr: "ascorbic acid-bioflavonoids oral",
  },
  {
    allergyType: "2",
    allergyId: "2108,2109",
    ROUTED_MED_ID: 64129,
    Descr: "ascorbic acid-bromelains oral",
  },
  {
    allergyType: "2",
    allergyId: "59667,84301",
    ROUTED_MED_ID: 94055,
    Descr: "ascorbic acid-collagen, hydrolyzed oral",
  },
  {
    allergyType: "2",
    allergyId: "51958",
    ROUTED_MED_ID: 75087,
    Descr: "ascorbic acid-echinacea oral",
  },
  {
    allergyType: "2",
    allergyId: "81229",
    ROUTED_MED_ID: 171624,
    Descr: "ascorbic acid-elderberry fruit oral",
  },
  {
    allergyType: "2",
    allergyId: "16010",
    ROUTED_MED_ID: 63770,
    Descr: "ascorbic acid-menthol oral",
  },
  {
    allergyType: "2",
    allergyId: "65146",
    ROUTED_MED_ID: 152351,
    Descr: "ascorbic acid-multivitamin-minerals oral",
  },
  {
    allergyType: "2",
    allergyId: "75794",
    ROUTED_MED_ID: 171463,
    Descr: "ascorbic acid-multivitamin-minerals-msm oral",
  },
  {
    allergyType: "2",
    allergyId: "84465",
    ROUTED_MED_ID: 186109,
    Descr: "ascorbic acid-olive leaf extract-beta-glucan oral",
  },
  {
    allergyType: "2",
    allergyId: "81247,85781",
    ROUTED_MED_ID: 179641,
    Descr: "ascorbic acid-vit D3-vit E-zinc gluconate-elderberry oral",
  },
  {
    allergyType: "2",
    allergyId: "72229,85065",
    ROUTED_MED_ID: 166057,
    Descr: "ascorbic acid-vitamin E-biotin oral",
  },
  {
    allergyType: "2",
    allergyId: "21281",
    ROUTED_MED_ID: 76988,
    Descr: "ascorbic acid-vitamin E-quin oral",
  },
  {
    allergyType: "2",
    allergyId: "16416",
    ROUTED_MED_ID: 63444,
    Descr: "ascorbic acid-vitamin E-zinc oral",
  },
  {
    allergyType: "2",
    allergyId: "53487",
    ROUTED_MED_ID: 78334,
    Descr: "ascorbic acid-zinc gluc-pectin mucous membrane",
  },
  {
    allergyType: "2",
    allergyId: "82487",
    ROUTED_MED_ID: 162603,
    Descr: "ascorbic acid-zinc oxide oral",
  },
  {
    allergyType: "2",
    allergyId: "37033,40795",
    ROUTED_MED_ID: 76446,
    Descr: "ascorbic acid-zinc-echinacea oral",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 58231,
    Descr: "Ascorbicap oral",
  },
  {
    allergyType: "0",
    allergyId: "10611",
    ROUTED_MED_ID: 0,
    Descr: "ascorbyl monophosphate",
  },
  {
    allergyType: "2",
    allergyId: "66984",
    ROUTED_MED_ID: 155226,
    Descr: "ascorbyl palmitate (bulk)",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 58229,
    Descr: "Ascorgard oral",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 58230,
    Descr: "Ascorvite oral",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 58241,
    Descr: "Ascospan oral",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 58238,
    Descr: "Ascot oral",
  },
  {
    allergyType: "1",
    allergyId: "2124",
    ROUTED_MED_ID: 9007,
    Descr: "Ascot SA oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 10154,
    Descr: "Ascriptin A/D oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 22318,
    Descr: "Ascriptin AP oral",
  },
  {
    allergyType: "1",
    allergyId: "4338",
    ROUTED_MED_ID: 11430,
    Descr: "Ascriptin Extra Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "4338",
    ROUTED_MED_ID: 22319,
    Descr: "Ascriptin MS oral",
  },
  {
    allergyType: "1",
    allergyId: "4335,4338,39786,39787",
    ROUTED_MED_ID: 6593,
    Descr: "Ascriptin oral",
  },
  {
    allergyType: "0",
    allergyId: "13233",
    ROUTED_MED_ID: 0,
    Descr: "asenapine",
  },
  {
    allergyType: "2",
    allergyId: "65537,65538,73981",
    ROUTED_MED_ID: 152900,
    Descr: "asenapine sublingual",
  },
  {
    allergyType: "2",
    allergyId: "80406,80407,80408",
    ROUTED_MED_ID: 178265,
    Descr: "asenapine transdermal",
  },
  {
    allergyType: "1",
    allergyId: "46081,46082,46083,46084",
    ROUTED_MED_ID: 6171,
    Descr: "Asendin oral",
  },
  {
    allergyType: "0",
    allergyId: "4255",
    ROUTED_MED_ID: 0,
    Descr: "aseptic technique test kits",
  },
  {
    allergyType: "2",
    allergyId: "19747",
    ROUTED_MED_ID: 77520,
    Descr: "aseptic technique test kits",
  },
  {
    allergyType: "0",
    allergyId: "4981",
    ROUTED_MED_ID: 0,
    Descr: "aseptic test kit extension sets",
  },
  {
    allergyType: "1",
    allergyId: "22223",
    ROUTED_MED_ID: 8049,
    Descr: "Asepto Basal Thermometer",
  },
  {
    allergyType: "1",
    allergyId: "10732,19532",
    ROUTED_MED_ID: 77996,
    Descr: "Asepto Bulb",
  },
  {
    allergyType: "1",
    allergyId: "10732,19532",
    ROUTED_MED_ID: 12585,
    Descr: "Asepto Bulb Syringes",
  },
  {
    allergyType: "1",
    allergyId: "11164",
    ROUTED_MED_ID: 16274,
    Descr: "Asepto Fever Thermometer,Oral",
  },
  {
    allergyType: "1",
    allergyId: "22225",
    ROUTED_MED_ID: 14332,
    Descr: "Asepto Fever Thermometer,Rectal",
  },
  {
    allergyType: "0",
    allergyId: "16528",
    ROUTED_MED_ID: 0,
    Descr: "asfotase alfa",
  },
  {
    allergyType: "2",
    allergyId: "74972,74973,75031,75032",
    ROUTED_MED_ID: 170276,
    Descr: "asfotase alfa subcutaneous",
  },
  {
    allergyType: "1",
    allergyId: "60937",
    ROUTED_MED_ID: 167918,
    Descr: "Ashlyna oral",
  },
  {
    allergyType: "2",
    allergyId: "62719",
    ROUTED_MED_ID: 148386,
    Descr: "ashwag rt-magno bark-epimed k-thean-phosptidyl oral",
  },
  {
    allergyType: "0",
    allergyId: "7851",
    ROUTED_MED_ID: 0,
    Descr: "ashwagandha",
  },
  {
    allergyType: "3",
    allergyId: "94",
    ROUTED_MED_ID: 0,
    Descr: "ASHWAGANDHA",
  },
  {
    allergyType: "2",
    allergyId: "84303,85893",
    ROUTED_MED_ID: 185773,
    Descr: "ashwagandha extract oral",
  },
  {
    allergyType: "2",
    allergyId: "70171",
    ROUTED_MED_ID: 162741,
    Descr: "ashwagandha root extract (bulk)",
  },
  {
    allergyType: "2",
    allergyId: "76082,81694,85517",
    ROUTED_MED_ID: 171990,
    Descr: "ashwagandha root extract oral",
  },
  {
    allergyType: "2",
    allergyId: "83415",
    ROUTED_MED_ID: 184206,
    Descr: "ashwagandha-magnolia-Phellodendrn-banaba-maral-theanine oral",
  },
  {
    allergyType: "3",
    allergyId: "900409",
    ROUTED_MED_ID: 0,
    Descr: "ASIATIC DOGWOOD",
  },
  {
    allergyType: "0",
    allergyId: "9680",
    ROUTED_MED_ID: 0,
    Descr: "Asiatic dogwood",
  },
  {
    allergyType: "1",
    allergyId: "158",
    ROUTED_MED_ID: 55945,
    Descr: "Asma oral",
  },
  {
    allergyType: "1",
    allergyId: "45",
    ROUTED_MED_ID: 55964,
    Descr: "Asma-Eze oral",
  },
  {
    allergyType: "1",
    allergyId: "45",
    ROUTED_MED_ID: 55965,
    Descr: "Asma-Leif oral",
  },
  {
    allergyType: "1",
    allergyId: "157",
    ROUTED_MED_ID: 55936,
    Descr: "Asma-Liquid oral",
  },
  {
    allergyType: "1",
    allergyId: "157,170",
    ROUTED_MED_ID: 55913,
    Descr: "Asmalan oral",
  },
  {
    allergyType: "1",
    allergyId: "76",
    ROUTED_MED_ID: 10731,
    Descr: "Asmalix oral",
  },
  {
    allergyType: "1",
    allergyId: "66573",
    ROUTED_MED_ID: 156971,
    Descr: "Asmalpred oral",
  },
  {
    allergyType: "1",
    allergyId: "66573",
    ROUTED_MED_ID: 154500,
    Descr: "Asmalpred Plus oral",
  },
  {
    allergyType: "1",
    allergyId: "73197,73198,80669",
    ROUTED_MED_ID: 167444,
    Descr: "Asmanex HFA inhalation",
  },
  {
    allergyType: "1",
    allergyId: "51649,59326,59327,59328,64010,64012",
    ROUTED_MED_ID: 93720,
    Descr: "Asmanex Twisthaler inhalation",
  },
  {
    allergyType: "1",
    allergyId: "45",
    ROUTED_MED_ID: 55969,
    Descr: "Asminyl oral",
  },
  {
    allergyType: "1",
    allergyId: "13003",
    ROUTED_MED_ID: 20831,
    Descr: "ASP 300/200/20 oral",
  },
  {
    allergyType: "1",
    allergyId: "13003",
    ROUTED_MED_ID: 57704,
    Descr: "Asp oral",
  },
  {
    allergyType: "0",
    allergyId: "2673",
    ROUTED_MED_ID: 0,
    Descr: "asparaginase",
  },
  {
    allergyType: "0",
    allergyId: "4466",
    ROUTED_MED_ID: 0,
    Descr: "asparaginase (Erwinia chrysanthemi)",
  },
  {
    allergyType: "2",
    allergyId: "68189",
    ROUTED_MED_ID: 158468,
    Descr: "asparaginase (Erwinia chrysanthemi) injection",
  },
  {
    allergyType: "3",
    allergyId: "567",
    ROUTED_MED_ID: 0,
    Descr: "ASPARAGINASE - E. COLI",
  },
  {
    allergyType: "3",
    allergyId: "568",
    ROUTED_MED_ID: 0,
    Descr: "ASPARAGINASE - ERWINIA",
  },
  {
    allergyType: "3",
    allergyId: "569",
    ROUTED_MED_ID: 0,
    Descr: "ASPARAGINASE - PEG, E. COLI",
  },
  {
    allergyType: "0",
    allergyId: "18795",
    ROUTED_MED_ID: 0,
    Descr: "asparaginase Erwinia chrysanthemi-rywn",
  },
  {
    allergyType: "2",
    allergyId: "82476",
    ROUTED_MED_ID: 181867,
    Descr: "asparaginase Erwinia-rywn intramuscular",
  },
  {
    allergyType: "2",
    allergyId: "8837",
    ROUTED_MED_ID: 5892,
    Descr: "asparaginase injection",
  },
  {
    allergyType: "0",
    allergyId: "6909",
    ROUTED_MED_ID: 0,
    Descr: "asparagine",
  },
  {
    allergyType: "3",
    allergyId: "453",
    ROUTED_MED_ID: 0,
    Descr: "ASPARAGINE",
  },
  {
    allergyType: "2",
    allergyId: "41892,68157",
    ROUTED_MED_ID: 76447,
    Descr: "asparagine monohydrate (bulk)",
  },
  {
    allergyType: "3",
    allergyId: "1062",
    ROUTED_MED_ID: 0,
    Descr: "ASPARAGUS",
  },
  {
    allergyType: "0",
    allergyId: "6500",
    ROUTED_MED_ID: 0,
    Descr: "asparagus",
  },
  {
    allergyType: "0",
    allergyId: "8375",
    ROUTED_MED_ID: 0,
    Descr: "asparagus flavor",
  },
  {
    allergyType: "0",
    allergyId: "14710",
    ROUTED_MED_ID: 0,
    Descr: "Asparagus racemosus",
  },
  {
    allergyType: "1",
    allergyId: "79422",
    ROUTED_MED_ID: 178047,
    Descr: "Asparlas intravenous",
  },
  {
    allergyType: "0",
    allergyId: "2605",
    ROUTED_MED_ID: 0,
    Descr: "aspartame",
  },
  {
    allergyType: "2",
    allergyId: "48696",
    ROUTED_MED_ID: 7215,
    Descr: "aspartame (bulk)",
  },
  {
    allergyType: "1",
    allergyId: "48696",
    ROUTED_MED_ID: 8177,
    Descr: "Aspartame (Nutrasweet)",
  },
  {
    allergyType: "1",
    allergyId: "1397",
    ROUTED_MED_ID: 86539,
    Descr: "Aspartate-Mg+K oral",
  },
  {
    allergyType: "0",
    allergyId: "933",
    ROUTED_MED_ID: 0,
    Descr: "aspartic acid",
  },
  {
    allergyType: "3",
    allergyId: "467",
    ROUTED_MED_ID: 0,
    Descr: "ASPARTIC ACID",
  },
  {
    allergyType: "2",
    allergyId: "1885",
    ROUTED_MED_ID: 7911,
    Descr: "aspartic acid (bulk)",
  },
  {
    allergyType: "2",
    allergyId: "14160",
    ROUTED_MED_ID: 10214,
    Descr: "aspartic acid oral",
  },
  {
    allergyType: "0",
    allergyId: "13521",
    ROUTED_MED_ID: 0,
    Descr: "aspen",
  },
  {
    allergyType: "3",
    allergyId: "937",
    ROUTED_MED_ID: 0,
    Descr: "ASPEN (POPULUS TREMULOIDES)",
  },
  {
    allergyType: "1",
    allergyId: "6137",
    ROUTED_MED_ID: 148312,
    Descr: "Asper-Flex topical",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 57496,
    Descr: "Aspercin oral",
  },
  {
    allergyType: "1",
    allergyId: "75061,80206",
    ROUTED_MED_ID: 170340,
    Descr: "Aspercreme (lidocaine HCl) topical",
  },
  {
    allergyType: "1",
    allergyId: "23447,81007",
    ROUTED_MED_ID: 179904,
    Descr: "Aspercreme (lidocaine) topical",
  },
  {
    allergyType: "1",
    allergyId: "18293",
    ROUTED_MED_ID: 184632,
    Descr: "Aspercreme Arthritis Pain topical",
  },
  {
    allergyType: "1",
    allergyId: "22072",
    ROUTED_MED_ID: 151895,
    Descr: "Aspercreme Heat topical",
  },
  {
    allergyType: "1",
    allergyId: "6033",
    ROUTED_MED_ID: 61800,
    Descr: "Aspercreme Ice topical",
  },
  {
    allergyType: "1",
    allergyId: "66001",
    ROUTED_MED_ID: 154253,
    Descr: "Aspercreme Max topical",
  },
  {
    allergyType: "1",
    allergyId: "6137,6139",
    ROUTED_MED_ID: 387,
    Descr: "Aspercreme topical",
  },
  {
    allergyType: "1",
    allergyId: "60115",
    ROUTED_MED_ID: 94727,
    Descr: "Aspercreme with Aloe topical",
  },
  {
    allergyType: "1",
    allergyId: "64522",
    ROUTED_MED_ID: 151425,
    Descr: "AsperDrink oral",
  },
  {
    allergyType: "1",
    allergyId: "83026",
    ROUTED_MED_ID: 183541,
    Descr: "AsperFlex (lidocaine HCl) topical",
  },
  {
    allergyType: "1",
    allergyId: "23447,40262",
    ROUTED_MED_ID: 180759,
    Descr: "AsperFlex (lidocaine) topical",
  },
  {
    allergyType: "1",
    allergyId: "85502",
    ROUTED_MED_ID: 183161,
    Descr: "AsperFlex Advance topical",
  },
  {
    allergyType: "1",
    allergyId: "62767",
    ROUTED_MED_ID: 183160,
    Descr: "AsperFlex Hot topical",
  },
  {
    allergyType: "1",
    allergyId: "68770",
    ROUTED_MED_ID: 183113,
    Descr: "AsperFlex Max topical",
  },
  {
    allergyType: "1",
    allergyId: "66595",
    ROUTED_MED_ID: 183484,
    Descr: "AsperFlex Menthol topical",
  },
  {
    allergyType: "2",
    allergyId: "58086",
    ROUTED_MED_ID: 91681,
    Descr: "aspergillus fumigatis allergenic extract intradermal",
  },
  {
    allergyType: "2",
    allergyId: "13654",
    ROUTED_MED_ID: 1042,
    Descr: "aspergillus fumigatis intradermal",
  },
  {
    allergyType: "0",
    allergyId: "8724",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus fumigatus allergenic extract",
  },
  {
    allergyType: "1",
    allergyId: "74552",
    ROUTED_MED_ID: 169473,
    Descr: "Aspergillus Fumigatus subcutaneous",
  },
  {
    allergyType: "0",
    allergyId: "11357",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus nidulans",
  },
  {
    allergyType: "0",
    allergyId: "16684",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus niger allergenic extract",
  },
  {
    allergyType: "0",
    allergyId: "16683",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus oryzae allergenic extract",
  },
  {
    allergyType: "0",
    allergyId: "1237",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus oryzae enzymes",
  },
  {
    allergyType: "0",
    allergyId: "16686",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus repens allergenic extract",
  },
  {
    allergyType: "0",
    allergyId: "16687",
    ROUTED_MED_ID: 0,
    Descr: "Aspergillus terreus allergenic extract",
  },
  {
    allergyType: "1",
    allergyId: "4386",
    ROUTED_MED_ID: 13974,
    Descr: "Aspergum oral",
  },
  {
    allergyType: "1",
    allergyId: "6137",
    ROUTED_MED_ID: 61833,
    Descr: "Aspi-Rub topical",
  },
  {
    allergyType: "0",
    allergyId: "2974",
    ROUTED_MED_ID: 0,
    Descr: "aspidium",
  },
  {
    allergyType: "1",
    allergyId: "4384",
    ROUTED_MED_ID: 57429,
    Descr: "Aspir-10 oral",
  },
  {
    allergyType: "1",
    allergyId: "16995",
    ROUTED_MED_ID: 4843,
    Descr: "Aspir-81 oral",
  },
  {
    allergyType: "1",
    allergyId: "16995",
    ROUTED_MED_ID: 14275,
    Descr: "Aspir-Low oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 10166,
    Descr: "Aspir-Lox AD oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 10161,
    Descr: "Aspir-Lox oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 91454,
    Descr: "Aspir-Mox (with aluminum) oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 6684,
    Descr: "Aspir-Mox IB oral",
  },
  {
    allergyType: "1",
    allergyId: "27896",
    ROUTED_MED_ID: 57491,
    Descr: "Aspir-Mox oral",
  },
  {
    allergyType: "1",
    allergyId: "4381,4384",
    ROUTED_MED_ID: 958,
    Descr: "Aspir-Trin oral",
  },
  {
    allergyType: "1",
    allergyId: "19541",
    ROUTED_MED_ID: 12636,
    Descr: "Aspirating Needles",
  },
  {
    allergyType: "1",
    allergyId: "10828",
    ROUTED_MED_ID: 62803,
    Descr: "Aspiration-Inject Disc Filter",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 15831,
    Descr: "Aspircaf oral",
  },
  {
    allergyType: "0",
    allergyId: "1587",
    ROUTED_MED_ID: 0,
    Descr: "aspirin",
  },
  {
    allergyType: "2",
    allergyId: "4365,61289",
    ROUTED_MED_ID: 77678,
    Descr: "aspirin (bulk)",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 1945,
    Descr: "Aspirin AD/Antacid oral",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 57697,
    Descr: "Aspirin And Caffeine oral",
  },
  {
    allergyType: "1",
    allergyId: "4335,4338",
    ROUTED_MED_ID: 14205,
    Descr: "Aspirin Buf(AlHyd-MgHyd-CaCar) oral",
  },
  {
    allergyType: "1",
    allergyId: "4334,27896",
    ROUTED_MED_ID: 18157,
    Descr: "Aspirin Buf(CaCarb-MgCarb-MgO) oral",
  },
  {
    allergyType: "1",
    allergyId: "27904",
    ROUTED_MED_ID: 5966,
    Descr: "Aspirin Buff (Al Hyd-Mg Hyd) oral",
  },
  {
    allergyType: "1",
    allergyId: "27884",
    ROUTED_MED_ID: 18713,
    Descr: "Aspirin Buff(MgCarb-AlAminoac) oral",
  },
  {
    allergyType: "1",
    allergyId: "27896",
    ROUTED_MED_ID: 63259,
    Descr: "Aspirin Buffered oral",
  },
  {
    allergyType: "1",
    allergyId: "4380",
    ROUTED_MED_ID: 14063,
    Descr: "Aspirin Child oral",
  },
  {
    allergyType: "1",
    allergyId: "4380",
    ROUTED_MED_ID: 13792,
    Descr: "Aspirin Childrens oral",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 57695,
    Descr: "Aspirin Compound oral",
  },
  {
    allergyType: "1",
    allergyId: "4388",
    ROUTED_MED_ID: 8886,
    Descr: "Aspirin CR oral",
  },
  {
    allergyType: "1",
    allergyId: "4381,4385",
    ROUTED_MED_ID: 3881,
    Descr: "Aspirin EC oral",
  },
  {
    allergyType: "1",
    allergyId: "4329,4330",
    ROUTED_MED_ID: 4785,
    Descr: "Aspirin Effervescent oral",
  },
  {
    allergyType: "1",
    allergyId: "4376,4381,4384",
    ROUTED_MED_ID: 57383,
    Descr: "Aspirin Enseal oral",
  },
  {
    allergyType: "1",
    allergyId: "4377,4383",
    ROUTED_MED_ID: 5093,
    Descr: "Aspirin Extra Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "4380",
    ROUTED_MED_ID: 57404,
    Descr: "Aspirin For Children oral",
  },
  {
    allergyType: "1",
    allergyId: "3699",
    ROUTED_MED_ID: 18926,
    Descr: "Aspirin Free Anacin PM oral",
  },
  {
    allergyType: "1",
    allergyId: "4469",
    ROUTED_MED_ID: 19668,
    Descr: "Aspirin Free Analgesic oral",
  },
  {
    allergyType: "1",
    allergyId: "4484",
    ROUTED_MED_ID: 57629,
    Descr: "Aspirin Free Children's Elixir oral",
  },
  {
    allergyType: "1",
    allergyId: "4481,4494",
    ROUTED_MED_ID: 1946,
    Descr: "Aspirin Free Childs oral",
  },
  {
    allergyType: "1",
    allergyId: "45648",
    ROUTED_MED_ID: 54978,
    Descr: "Aspirin Free Cold oral",
  },
  {
    allergyType: "1",
    allergyId: "4490",
    ROUTED_MED_ID: 11651,
    Descr: "Aspirin Free Extra Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "3699",
    ROUTED_MED_ID: 57183,
    Descr: "Aspirin Free Headache PM oral",
  },
  {
    allergyType: "1",
    allergyId: "4481,4489,4490",
    ROUTED_MED_ID: 57567,
    Descr: "Aspirin Free oral",
  },
  {
    allergyType: "1",
    allergyId: "4473,4489,4490",
    ROUTED_MED_ID: 57528,
    Descr: "Aspirin Free Pain Relief oral",
  },
  {
    allergyType: "1",
    allergyId: "3699",
    ROUTED_MED_ID: 75013,
    Descr: "Aspirin Free PM oral",
  },
  {
    allergyType: "1",
    allergyId: "6137",
    ROUTED_MED_ID: 78328,
    Descr: "Aspirin Free topical",
  },
  {
    allergyType: "1",
    allergyId: "4376",
    ROUTED_MED_ID: 57393,
    Descr: "Aspirin Lite Coat oral",
  },
  {
    allergyType: "1",
    allergyId: "4376",
    ROUTED_MED_ID: 57394,
    Descr: "Aspirin Lite-Coat oral",
  },
  {
    allergyType: "1",
    allergyId: "4380",
    ROUTED_MED_ID: 11672,
    Descr: "Aspirin Low Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "4380,16995",
    ROUTED_MED_ID: 32707,
    Descr: "Aspirin Low-Strength oral",
  },
  {
    allergyType: "1",
    allergyId: "4377,4383",
    ROUTED_MED_ID: 4143,
    Descr: "Aspirin Maximum Strength oral",
  },
  {
    allergyType: "2",
    allergyId:
      "4338,4361,4376,4377,4380,4381,4382,4383,4384,4385,4386,4387,4388,12000,16656,16995,22159,24574,24575,24576,41823,64522,64934,82518",
    ROUTED_MED_ID: 1082,
    Descr: "aspirin oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 57494,
    Descr: "Aspirin Plus Antacid oral",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 57689,
    Descr: "Aspirin Plus oral",
  },
  {
    allergyType: "2",
    allergyId: "4366,4367,4368,4369,4370,4371,4373,4374,4375",
    ROUTED_MED_ID: 4088,
    Descr: "aspirin rectal",
  },
  {
    allergyType: "1",
    allergyId: "31299",
    ROUTED_MED_ID: 15989,
    Descr: "Aspirin Regimen Bayer/Calcium oral",
  },
  {
    allergyType: "1",
    allergyId: "4338",
    ROUTED_MED_ID: 20726,
    Descr: "Aspirin Tri Buffered oral",
  },
  {
    allergyType: "1",
    allergyId: "4334,27896",
    ROUTED_MED_ID: 57504,
    Descr: "Aspirin Tri-Buffered oral",
  },
  {
    allergyType: "1",
    allergyId: "27896",
    ROUTED_MED_ID: 57506,
    Descr: "Aspirin W/Aluminum/Magnesium oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 57490,
    Descr: "Aspirin W/Antacid oral",
  },
  {
    allergyType: "1",
    allergyId: "4319",
    ROUTED_MED_ID: 57687,
    Descr: "Aspirin W/Caffeine oral",
  },
  {
    allergyType: "1",
    allergyId: "4146,4147",
    ROUTED_MED_ID: 57835,
    Descr: "Aspirin W/Codeine oral",
  },
  {
    allergyType: "1",
    allergyId: "4334,27896",
    ROUTED_MED_ID: 567,
    Descr: "aspirin, buffered oral",
  },
  {
    allergyType: "2",
    allergyId: "11997",
    ROUTED_MED_ID: 9857,
    Descr: "aspirin, buffered-caffeine oral",
  },
  {
    allergyType: "2",
    allergyId: "52768,52769,52770,52771,52772,52773",
    ROUTED_MED_ID: 76311,
    Descr: "aspirin, buffered-pravastatin oral",
  },
  {
    allergyType: "2",
    allergyId: "4334,27893,27896,66232",
    ROUTED_MED_ID: 178377,
    Descr: "aspirin,buffered (calcium carbonate-magnesium) oral",
  },
  {
    allergyType: "2",
    allergyId: "27884",
    ROUTED_MED_ID: 178363,
    Descr: "aspirin,buffered (mag carb-dihydroxyaluminum aminoacet) oral",
  },
  {
    allergyType: "2",
    allergyId: "27885,27904",
    ROUTED_MED_ID: 178376,
    Descr: "aspirin,buffered (magnesium and aluminum hydroxide) oral",
  },
  {
    allergyType: "2",
    allergyId: "4335,4338,39786,39787",
    ROUTED_MED_ID: 178362,
    Descr: "aspirin,buffered(calcium carb-magnesium-aluminum hydrx) oral",
  },
  {
    allergyType: "2",
    allergyId: "62800",
    ROUTED_MED_ID: 148545,
    Descr: "aspirin-acetaminophen (buffered) oral",
  },
  {
    allergyType: "2",
    allergyId: "59810",
    ROUTED_MED_ID: 94307,
    Descr: "aspirin-acetaminophen oral",
  },
  {
    allergyType: "2",
    allergyId: "4344,34096,40186,47014,62538,63527,70842,83546",
    ROUTED_MED_ID: 103,
    Descr: "aspirin-acetaminophen-caffeine oral",
  },
  {
    allergyType: "2",
    allergyId: "81965",
    ROUTED_MED_ID: 180933,
    Descr: "aspirin-acetaminophen-diphenhydramine oral",
  },
  {
    allergyType: "2",
    allergyId: "4318,4319,4320,65991,66247,66381,68068,83536",
    ROUTED_MED_ID: 1633,
    Descr: "aspirin-caffeine oral",
  },
  {
    allergyType: "2",
    allergyId: "4212,62407",
    ROUTED_MED_ID: 12343,
    Descr: "aspirin-caffeine-dihydrocodeine oral",
  },
  {
    allergyType: "2",
    allergyId: "31299,68853",
    ROUTED_MED_ID: 13890,
    Descr: "aspirin-calcium carbonate oral",
  },
  {
    allergyType: "2",
    allergyId: "5093",
    ROUTED_MED_ID: 9858,
    Descr: "aspirin-cinnamedrine-caffeine oral",
  },
  {
    allergyType: "1",
    allergyId: "4146",
    ROUTED_MED_ID: 1948,
    Descr: "Aspirin-Codeine #3 oral",
  },
  {
    allergyType: "1",
    allergyId: "4147",
    ROUTED_MED_ID: 1949,
    Descr: "Aspirin-Codeine #4 oral",
  },
  {
    allergyType: "2",
    allergyId: "4146,4147",
    ROUTED_MED_ID: 1947,
    Descr: "aspirin-codeine oral",
  },
  {
    allergyType: "2",
    allergyId: "4131",
    ROUTED_MED_ID: 94642,
    Descr: "aspirin-codeine-buffers oral",
  },
  {
    allergyType: "2",
    allergyId: "67359",
    ROUTED_MED_ID: 155827,
    Descr: "aspirin-diphenhydramine citrate oral",
  },
  {
    allergyType: "2",
    allergyId: "24790,39716",
    ROUTED_MED_ID: 1950,
    Descr: "aspirin-diphenhydramine oral",
  },
  {
    allergyType: "2",
    allergyId: "40303",
    ROUTED_MED_ID: 17175,
    Descr: "aspirin-dipyridamole oral",
  },
  {
    allergyType: "1",
    allergyId: "4381",
    ROUTED_MED_ID: 57411,
    Descr: "Aspirin-For-Arthritis oral",
  },
  {
    allergyType: "1",
    allergyId: "4481",
    ROUTED_MED_ID: 57641,
    Descr: "Aspirin-Free Children's oral",
  },
  {
    allergyType: "1",
    allergyId: "4486",
    ROUTED_MED_ID: 57655,
    Descr: "Aspirin-Free Infant Drops oral",
  },
  {
    allergyType: "1",
    allergyId: "4486",
    ROUTED_MED_ID: 57662,
    Descr: "Aspirin-Free Infant oral",
  },
  {
    allergyType: "1",
    allergyId: "4481,4486,4490",
    ROUTED_MED_ID: 57590,
    Descr: "Aspirin-Free oral",
  },
  {
    allergyType: "1",
    allergyId: "4489,4490",
    ROUTED_MED_ID: 57552,
    Descr: "Aspirin-Free Pain Relief oral",
  },
  {
    allergyType: "1",
    allergyId: "4490",
    ROUTED_MED_ID: 57591,
    Descr: "Aspirin-Free Relief oral",
  },
  {
    allergyType: "2",
    allergyId: "76607,76608",
    ROUTED_MED_ID: 172549,
    Descr: "aspirin-omeprazole oral",
  },
  {
    allergyType: "1",
    allergyId: "4219",
    ROUTED_MED_ID: 1952,
    Descr: "Aspirin-Oxycodone oral",
  },
  {
    allergyType: "2",
    allergyId: "4321,4322,12002",
    ROUTED_MED_ID: 10545,
    Descr: "aspirin-salicylamide-caffeine oral",
  },
  {
    allergyType: "2",
    allergyId: "4329,4330,51163,59732,73553,85538",
    ROUTED_MED_ID: 94207,
    Descr: "aspirin-sodium bicarbonate-citric acid oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 1523,
    Descr: "Aspirin/Antacid oral",
  },
  {
    allergyType: "1",
    allergyId: "4377",
    ROUTED_MED_ID: 149381,
    Descr: "Aspirina oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 57500,
    Descr: "Aspirlox oral",
  },
  {
    allergyType: "1",
    allergyId: "4484,4486,4489,4490,4494",
    ROUTED_MED_ID: 57569,
    Descr: "Aspirnil oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 57497,
    Descr: "Aspralum E.B. oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 11259,
    Descr: "Aspralum EB oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 11258,
    Descr: "Aspralum oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 57498,
    Descr: "Aspri-Mox oral",
  },
  {
    allergyType: "1",
    allergyId: "4335",
    ROUTED_MED_ID: 13932,
    Descr: "Aspridrox oral",
  },
  {
    allergyType: "1",
    allergyId: "27904",
    ROUTED_MED_ID: 57488,
    Descr: "Asprimox E/P oral",
  },
  {
    allergyType: "1",
    allergyId: "4335,4338",
    ROUTED_MED_ID: 57492,
    Descr: "Asprimox ID oral",
  },
  {
    allergyType: "1",
    allergyId: "4335,27904",
    ROUTED_MED_ID: 57489,
    Descr: "Asprimox oral",
  },
  {
    allergyType: "1",
    allergyId: "16995",
    ROUTED_MED_ID: 63991,
    Descr: "Asprin Ec Low Dose oral",
  },
  {
    allergyType: "1",
    allergyId: "4441",
    ROUTED_MED_ID: 57461,
    Descr: "Asproject injection",
  },
  {
    allergyType: "1",
    allergyId: "83128,83129",
    ROUTED_MED_ID: 184414,
    Descr: "Aspruzyo Sprinkle oral",
  },
  {
    allergyType: "1",
    allergyId: "85473",
    ROUTED_MED_ID: 187798,
    Descr: "AspyreRx Digital App (type 2 diabetes) (90-day)",
  },
  {
    allergyType: "0",
    allergyId: "12381",
    ROUTED_MED_ID: 0,
    Descr: "assembly sys,vial to transfer device,closed system",
  },
  {
    allergyType: "2",
    allergyId: "63260",
    ROUTED_MED_ID: 149374,
    Descr: "assembly system, vial to transfer device,closd sys",
  },
  {
    allergyType: "1",
    allergyId: "23835",
    ROUTED_MED_ID: 13121,
    Descr: "Assess Disposable Mouthpieces",
  },
  {
    allergyType: "1",
    allergyId: "16606",
    ROUTED_MED_ID: 76754,
    Descr: "Assess Full Range Peak Meter",
  },
  {
    allergyType: "1",
    allergyId: "16606",
    ROUTED_MED_ID: 76773,
    Descr: "Assess Low Range Peak Meter",
  },
  {
    allergyType: "1",
    allergyId: "16606",
    ROUTED_MED_ID: 13120,
    Descr: "Assess Peak Flow Meter",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 64791,
    Descr: "Assura 2pc Drainable",
  },
  {
    allergyType: "1",
    allergyId: "10185",
    ROUTED_MED_ID: 76661,
    Descr: "Assura 2pc Irrigation Sleeve",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91630,
    Descr: "Assura AC Baseplate",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91631,
    Descr: "Assura AC Closed Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10130,10131,10197,10222,10224,10226,10230,10300,10312",
    ROUTED_MED_ID: 91639,
    Descr: "Assura AC Convex Baseplate",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91637,
    Descr: "Assura AC Drain Pouch Maxi",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 148724,
    Descr: "Assura AC EasiClose Drainable Maxi",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91636,
    Descr: "Assura AC EasiClose Drainable Midi Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91650,
    Descr: "Assura AC EasiClose Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91627,
    Descr: "Assura Convex Closed Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10219,10233",
    ROUTED_MED_ID: 78205,
    Descr: "Assura Convex Easiclose Maxi Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10217",
    ROUTED_MED_ID: 91628,
    Descr: "Assura Convex Flange",
  },
  {
    allergyType: "1",
    allergyId: "10197,10217,10219,10222,10224,10226,10228,10230,10233",
    ROUTED_MED_ID: 91642,
    Descr: "Assura Convex Light Standard",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 148721,
    Descr: "Assura Convex One-Piece Drainable",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 148719,
    Descr: "Assura Convex Skin Barrier",
  },
  {
    allergyType: "1",
    allergyId: "10214,10217,10219,10222,10224,10233",
    ROUTED_MED_ID: 22076,
    Descr: "Assura Convex Skin Barrier Flange Pre-Cut",
  },
  {
    allergyType: "1",
    allergyId: "10219,10224,10226,10233",
    ROUTED_MED_ID: 75373,
    Descr: "Assura Convex Standard Wear Drainable",
  },
  {
    allergyType: "1",
    allergyId: "10219",
    ROUTED_MED_ID: 76495,
    Descr: "Assura Convex Uropouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 76498,
    Descr: "Assura Drainable Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197,61241",
    ROUTED_MED_ID: 76662,
    Descr: "Assura Easiclose Drainable",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 22146,
    Descr: "Assura Easiclose Drainable Pch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91378,
    Descr: "Assura EasiClose Maxi Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 148722,
    Descr: "Assura Easiclose Midi Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197,61409",
    ROUTED_MED_ID: 145047,
    Descr: "Assura EasiClose Mini Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197,10226,10233",
    ROUTED_MED_ID: 91655,
    Descr: "Assura EasiClose Wide Outlet Maxi Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10174",
    ROUTED_MED_ID: 22147,
    Descr: "Assura Extended Wear Flange",
  },
  {
    allergyType: "1",
    allergyId: "10197,10219,10222,10224,10226,10228,10230,10233",
    ROUTED_MED_ID: 76499,
    Descr: "Assura Extra Convex Flange",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91635,
    Descr: "Assura Extra Convex Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 76756,
    Descr: "Assura Extra Non-Convex Drain",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91377,
    Descr: "Assura Extra Non-Convex Flange",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91629,
    Descr: "Assura Extra Non-Convex Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10214,10230,42877",
    ROUTED_MED_ID: 76496,
    Descr: "Assura Flange",
  },
  {
    allergyType: "1",
    allergyId: "10228,10230,42877",
    ROUTED_MED_ID: 86540,
    Descr: "Assura Flange Convex",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 148741,
    Descr: "Assura Ileo Night Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 22073,
    Descr: "Assura Irrig Fce Plt 1/2-2 1/4",
  },
  {
    allergyType: "1",
    allergyId: "61241",
    ROUTED_MED_ID: 145707,
    Descr: "Assura Light Easiclose Drainable",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 76663,
    Descr: "Assura Non-Convex Drainable",
  },
  {
    allergyType: "1",
    allergyId: "10116",
    ROUTED_MED_ID: 86541,
    Descr: "Assura Ostomy Belt",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91664,
    Descr: "Assura Ped Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197,10262",
    ROUTED_MED_ID: 91626,
    Descr: "Assura Pediatric Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 148742,
    Descr: "Assura Pediatric Skin Barrier",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 91625,
    Descr: "Assura Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197,10219,10224,10228,10233",
    ROUTED_MED_ID: 148718,
    Descr: "Assura Skin Barrier Flange",
  },
  {
    allergyType: "1",
    allergyId: "10224",
    ROUTED_MED_ID: 76497,
    Descr: "Assura Standard Convex",
  },
  {
    allergyType: "1",
    allergyId: "61637",
    ROUTED_MED_ID: 145725,
    Descr: "Assura Standard Wear",
  },
  {
    allergyType: "1",
    allergyId: "10197",
    ROUTED_MED_ID: 76779,
    Descr: "Assura Standard Wear Urostomy Pouch",
  },
  {
    allergyType: "1",
    allergyId: "11237",
    ROUTED_MED_ID: 91722,
    Descr: "Assura Urostomy Pouch",
  },
  {
    allergyType: "1",
    allergyId: "10197,10235",
    ROUTED_MED_ID: 22069,
    Descr: "Assura Wound Manager 1/2-2 3/4",
  },
  {
    allergyType: "1",
    allergyId: "10197,10235",
    ROUTED_MED_ID: 22074,
    Descr: 'Assura Wound Manager 1/2-4"',
  },
  {
    allergyType: "1",
    allergyId: "22393",
    ROUTED_MED_ID: 5674,
    Descr: "Assurance Belted Undergarment",
  },
  {
    allergyType: "1",
    allergyId: "10362",
    ROUTED_MED_ID: 5675,
    Descr: "Assurance Bladder Control Pad",
  },
  {
    allergyType: "1",
    allergyId: "22393",
    ROUTED_MED_ID: 5673,
    Descr: "Assurance Fitted Brief",
  },
  {
    allergyType: "1",
    allergyId: "22393",
    ROUTED_MED_ID: 5676,
    Descr: "Assurance Undergarment",
  },
  {
    allergyType: "1",
    allergyId: "22400",
    ROUTED_MED_ID: 5672,
    Descr: "Assurance Underpads",
  },
  {
    allergyType: "1",
    allergyId: "22393",
    ROUTED_MED_ID: 172650,
    Descr: "Assurance Womens Underwear S-M",
  },
  {
    allergyType: "1",
    allergyId: "22393",
    ROUTED_MED_ID: 177063,
    Descr: "Assurance Womens Underwear XL",
  },
  {
    allergyType: "1",
    allergyId: "19413,19549,50327",
    ROUTED_MED_ID: 74932,
    Descr: "Assure",
  },
  {
    allergyType: "1",
    allergyId: "19549,62133",
    ROUTED_MED_ID: 64854,
    Descr: "Assure 3",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 77715,
    Descr: "Assure 3 Test",
  },
  {
    allergyType: "1",
    allergyId: "50327",
    ROUTED_MED_ID: 149372,
    Descr: "Assure 4 Control Solution",
  },
  {
    allergyType: "1",
    allergyId: "19413",
    ROUTED_MED_ID: 149370,
    Descr: "Assure 4 Meter",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 149371,
    Descr: "Assure 4 Strips",
  },
  {
    allergyType: "1",
    allergyId: "19413",
    ROUTED_MED_ID: 16542,
    Descr: "Assure Blood Glucose Meter",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 16543,
    Descr: "Assure Blood Glucose Meter Kit",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 77716,
    Descr: "Assure Check Test",
  },
  {
    allergyType: "1",
    allergyId: "50327",
    ROUTED_MED_ID: 16920,
    Descr: "Assure Control Solution",
  },
  {
    allergyType: "1",
    allergyId: "62136",
    ROUTED_MED_ID: 153459,
    Descr: "Assure Dose Normal Control",
  },
  {
    allergyType: "1",
    allergyId: "62139",
    ROUTED_MED_ID: 153466,
    Descr: "Assure Dose Normal-High Control",
  },
  {
    allergyType: "1",
    allergyId: "70184,70199,70200,70201,70878",
    ROUTED_MED_ID: 159929,
    Descr: "Assure Haemolance Plus",
  },
  {
    allergyType: "1",
    allergyId: "78529",
    ROUTED_MED_ID: 187996,
    Descr: "Assure ID Duo Pro Safety Pen Needle",
  },
  {
    allergyType: "1",
    allergyId: "68057,80835",
    ROUTED_MED_ID: 179749,
    Descr: "Assure ID DUO-Shield",
  },
  {
    allergyType: "1",
    allergyId: "67193,67194,78189,78190",
    ROUTED_MED_ID: 159740,
    Descr: "Assure ID Insulin Safety",
  },
  {
    allergyType: "1",
    allergyId: "78529,78535,78536",
    ROUTED_MED_ID: 175471,
    Descr: "Assure ID Pen Needle",
  },
  {
    allergyType: "1",
    allergyId: "78535",
    ROUTED_MED_ID: 187620,
    Descr: "Assure ID Pro Pen Needle",
  },
  {
    allergyType: "1",
    allergyId: "19413,19549,62133",
    ROUTED_MED_ID: 32917,
    Descr: "Assure II",
  },
  {
    allergyType: "1",
    allergyId: "19413",
    ROUTED_MED_ID: 22425,
    Descr: "Assure II Blood Glucose Meter",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 22426,
    Descr: "Assure II Blood Glucose System",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 22849,
    Descr: "Assure II Blood Glucose Type 2",
  },
  {
    allergyType: "1",
    allergyId: "19415,62135",
    ROUTED_MED_ID: 22427,
    Descr: "Assure II Control",
  },
  {
    allergyType: "1",
    allergyId: "19415,62133",
    ROUTED_MED_ID: 22428,
    Descr: "Assure II Control Level 1,2",
  },
  {
    allergyType: "1",
    allergyId: "62136",
    ROUTED_MED_ID: 163254,
    Descr: "Assure II Normal Control",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 77717,
    Descr: "Assure II Test",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 74931,
    Descr: "Assure in vitro",
  },
  {
    allergyType: "1",
    allergyId: "11186,70184,70199",
    ROUTED_MED_ID: 150706,
    Descr: "Assure Lance",
  },
  {
    allergyType: "1",
    allergyId: "70013,70199,70200",
    ROUTED_MED_ID: 168006,
    Descr: "Assure Lance Plus",
  },
  {
    allergyType: "1",
    allergyId: "16026",
    ROUTED_MED_ID: 60984,
    Descr: "Assure mucous membrane",
  },
  {
    allergyType: "1",
    allergyId: "19413",
    ROUTED_MED_ID: 154168,
    Descr: "Assure Platinum Glucose Meter",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 178636,
    Descr: "Assure Platinum Test Strip",
  },
  {
    allergyType: "1",
    allergyId: "62139",
    ROUTED_MED_ID: 168398,
    Descr: "Assure Prism Control 1-2 Solution",
  },
  {
    allergyType: "1",
    allergyId: "19413",
    ROUTED_MED_ID: 168012,
    Descr: "Assure Prism Multi Meter",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 168007,
    Descr: "Assure Prism Multi Strip",
  },
  {
    allergyType: "1",
    allergyId: "19549",
    ROUTED_MED_ID: 95357,
    Descr: "Assure Pro Blood Glucose Meter",
  },
  {
    allergyType: "1",
    allergyId: "62133",
    ROUTED_MED_ID: 95356,
    Descr: "Assure Pro Control",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 95352,
    Descr: "Assure Pro Test Strips",
  },
  {
    allergyType: "1",
    allergyId: "6373",
    ROUTED_MED_ID: 77695,
    Descr: "Assure Test",
  },
  {
    allergyType: "1",
    allergyId: "62896,62897,62898",
    ROUTED_MED_ID: 164845,
    Descr: "Astagraf XL oral",
  },
  {
    allergyType: "0",
    allergyId: "13263",
    ROUTED_MED_ID: 0,
    Descr: "astaxanthin",
  },
  {
    allergyType: "2",
    allergyId: "67710,81665",
    ROUTED_MED_ID: 156743,
    Descr: "astaxanthin oral",
  },
  {
    allergyType: "1",
    allergyId: "23835",
    ROUTED_MED_ID: 17002,
    Descr: "Astech Adapter",
  },
  {
    allergyType: "1",
    allergyId: "23835",
    ROUTED_MED_ID: 17001,
    Descr: "Astech Disposable Mouthpiece",
  },
  {
    allergyType: "1",
    allergyId: "16606",
    ROUTED_MED_ID: 11746,
    Descr: "Astech Peak Flow Meter",
  },
  {
    allergyType: "1",
    allergyId: "29893",
    ROUTED_MED_ID: 14535,
    Descr: "Astelin nasal",
  },
  {
    allergyType: "0",
    allergyId: "3413",
    ROUTED_MED_ID: 0,
    Descr: "astemizole",
  },
  {
    allergyType: "2",
    allergyId: "11659",
    ROUTED_MED_ID: 6824,
    Descr: "astemizole oral",
  },
  {
    allergyType: "1",
    allergyId: "65577",
    ROUTED_MED_ID: 184671,
    Descr: "Astepro Allergy nasal",
  },
  {
    allergyType: "1",
    allergyId: "29893,65577",
    ROUTED_MED_ID: 151463,
    Descr: "Astepro nasal",
  },
  {
    allergyType: "1",
    allergyId: "74857",
    ROUTED_MED_ID: 172287,
    Descr: "Astero topical",
  },
  {
    allergyType: "1",
    allergyId: "16606",
    ROUTED_MED_ID: 76776,
    Descr: "Asthma Check Meter",
  },
  {
    allergyType: "1",
    allergyId: "21900,21901",
    ROUTED_MED_ID: 21154,
    Descr: "Asthma Control Kit",
  },
  {
    allergyType: "1",
    allergyId: "45,16765",
    ROUTED_MED_ID: 55984,
    Descr: "Asthma oral",
  },
  {
    allergyType: "1",
    allergyId: "5061",
    ROUTED_MED_ID: 187603,
    Descr: "Asthma Relief oral",
  },
  {
    allergyType: "1",
    allergyId: "176,177",
    ROUTED_MED_ID: 6618,
    Descr: "Asthmahaler inhalation",
  },
  {
    allergyType: "1",
    allergyId: "176",
    ROUTED_MED_ID: 76804,
    Descr: "Asthmahaler Refill inhalation",
  },
  {
    allergyType: "1",
    allergyId: "16606",
    ROUTED_MED_ID: 76777,
    Descr: "AsthmaMentOr Peak Flow Meter",
  },
  {
    allergyType: "1",
    allergyId: "184",
    ROUTED_MED_ID: 959,
    Descr: "Asthmanefrin inhalation",
  },
  {
    allergyType: "1",
    allergyId: "11552",
    ROUTED_MED_ID: 997,
    Descr: "Asthmanefrin Nebulizer",
  },
  {
    allergyType: "1",
    allergyId: "54686",
    ROUTED_MED_ID: 161859,
    Descr: "Asthmanefrin Refill inhalation",
  },
  {
    allergyType: "1",
    allergyId: "54686",
    ROUTED_MED_ID: 161889,
    Descr: "Asthmanefrin Starter Kit inhalation",
  },
  {
    allergyType: "1",
    allergyId: "34669",
    ROUTED_MED_ID: 151610,
    Descr: "Asthmapack Children's",
  },
  {
    allergyType: "1",
    allergyId: "34669",
    ROUTED_MED_ID: 75225,
    Descr: "Asthmapack I",
  },
  {
    allergyType: "1",
    allergyId: "34669",
    ROUTED_MED_ID: 4725,
    Descr: "AsthmaPACK II",
  },
  {
    allergyType: "1",
    allergyId: "34669",
    ROUTED_MED_ID: 75226,
    Descr: "Asthmapack III",
  },
  {
    allergyType: "1",
    allergyId: "821",
    ROUTED_MED_ID: 86542,
    Descr: "Asthmatic Paroxysms No.21 oral",
  },
];



// WEBPACK FOOTER //
// ./src/providers/order-data-service/mock-config.ts